import _ from "lodash";
import React from "react";
import { FontAwesomeIcon } from "../components/shared/FontAwesomeIconWrapper";
import marked from "marked";
// import ls from "local-storage";
import isWebView from "is-ua-webview";
import mobile from "is-mobile";
import moment from "moment";
import qs from "qs";
import castit from "castit";
import * as deepmerge from "deepmerge";

import state from "../state";
import { cloneDeep } from "./newUtils";

// import * as Handlebars from "handlebars/dist/handlebars";

// import env from "../constants/env";
// import AWS from "aws-sdk";
// import { getOrgId } from "../actions/orgsActions";
// import FileSaver from "file-saver";
import { getObjectByGuid } from "../actions/modelActions";
import PlayerPaths from "../constants/paths/playerPaths";
import markdownStyles from "../constants/markdownStyles";
import matchReplaceAll from "match-replace-all";

import { getUrlForValue } from "../actions/drive";
import { getSelectedActivityId } from "../actions/playerActions";

let pathCache = {};
let findNode = null;

const STRING_TEMPLATE_VARIABLE = new RegExp("\\$\\{(.*?)}", "gm");
const HIERARCHICAL_STYLE_PROPS = ["fontFamily", "color", "fontWeight", "fontStyle", "fontSize"];

export function zeroPrefix(value) {
	if (value < 10) {
		return "0" + value;
	} else {
		return String(value);
	}
}

// export function getLs(key) {
// 	return getFromLocalStorage(key);
// }

// export function setLs(key, value) {
// 	setLocalStorage(key, value);
// }

// export function setLocalStorage(key, value) {
// 	ls(key, value);
// }

// export function getFromLocalStorage(key) {
// 	return ls(key);
// }

export function isNull(value) {
	return value === null || value === "undefined";
}

export function hasElement(arr, type, key) {
	const result = _.find(arr, [type, key]);

	return result ? result : null;
}

export function isDev() {
	// console.log("HOST", window.location.hostname);
	return (window.location.hostname === "localhost" || window.location.hostname === "dev-app.ambifi.com");
}

export function arrayToMap(arr, key) {
	let result = {};
	if (_.isArray(arr)) {
		arr.forEach(entry => {
			if (_.isString(key) && entry.hasOwnProperty(key)) {
				result[entry[key]] = entry;
			} else if (_.isFunction(key)) {
				result[key(entry)] = entry;
			} else {
				throw new Error(`Found an Object that does not contain the required key ${key} : ${JSON.stringify(entry)}`);
			}
		});
	}
	return result;
}

export function generateUUID() {
	let d = new Date().getTime();
	let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
		let r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16); // eslint-disable-line no-mixed-operators
	});
	return uuid;
}

export function getKeyPrefix(identityId) {
	let keyPrefix;

	if (identityId.indexOf(":") >= 0) {
		keyPrefix = identityId.split(":")[1];
	} else {
		keyPrefix = identityId;
	}

	//keyPrefix = "af861e5e-2fc6-49ee-b590-6ce4bb769a65";

	return keyPrefix;
}

export function truncateWithEllipses(text, max) {
	return text.substr(0, max - 1) + (text.length > max ? "..." : "");
}

export function getLabelFromValue(items, value) {
	let retValue = value;

	for (let i = 0; i < items.length; i++) {
		if (items[i].value === value) {
			retValue = items[i].label;
		}
	}

	return retValue;
}

export function isMobile() {
	return isWebView(navigator.userAgent);
}

export function isMobileBrowser() {
	return mobile({ tablet: true });
}

export function showLoader(tree) {
	tree.set(["appState", "loading"], true);
}

export function hideLoader(tree) {
	tree.set(["appState", "loading"], false);
}

function isActivityOfType(activity, type) {
	if (activity.children.length > 0 && activity.children[0].type.startsWith(type)) {
		return true;
	} else {
		return false;
	}
}

export function isActivityLists(activity) {
	return isActivityOfType(activity, "list");
}

export function isActivitySections(activity) {
	return isActivityOfType(activity, "section");
}

export function isActivityItems(activity) {
	return isActivityOfType(activity, "item");
}

function normalizeActivityFromSections(activity) {
	let newActivity = _.cloneDeep(activity);

	let list = {
		"type": "list",
		"completionState": "n",
		"name": "Sections",
		"defaultView": "checklistView",
		"color": "black",
		"horzScrollPos": 0,
		"vertScrollPos": 0,
		"insertedByNormalization": true,
		"children": _.cloneDeep(activity.children)
	};

	newActivity.children = [];
	newActivity.children.push(list);

	return newActivity;
}

function normalizeActivityFromItems(activity) {
	let newActivity = _.cloneDeep(activity);

	let list = {
		"type": "list",
		"completionState": "n",
		"name": "Sections",
		"defaultView": "checklistView",
		"color": "black",
		"horzScrollPos": 0,
		"vertScrollPos": 0,
		"insertedByNormalization": true,
		"children": [
			{
				"type": "section",
				"completionState": "n",
				"name": "Items",
				"vertScrollPos": 0,
				"insertedByNormalization": true,
				"children": _.cloneDeep(activity.children)
			}
		]
	};

	newActivity.children = [];
	newActivity.children.push(list);

	return newActivity;
}

export function normalizeActivity(activity) {

	//Only set first level if it already hasn't been set. When loading from S3
	//the firstLevel will always be lists because it is saved in an already normalized state
	if (isActivityLists(activity)) {
		if (_.isUndefined(activity.firstLevel)) { activity.firstLevel = "lists"; }
		return activity;
	} else if (isActivitySections(activity)) {
		if (_.isUndefined(activity.firstLevel)) { activity.firstLevel = "sections"; }
		return normalizeActivityFromSections(activity);
	} else if (isActivityItems(activity)) {
		if (_.isUndefined(activity.firstLevel)) { activity.firstLevel = "items"; }
		return normalizeActivityFromItems(activity);
	} else {
		activity.firstLevel = "null";
		return activity;
	}
}

// export async function publishActivity(activity) {
// 	if (activity.hasOwnProperty("contentModel") && activity.contentModel !== "") {
// 		// Set Content Model...for now just support one, but eventually multiple
// 		const s3 = new AWS.S3({ useDualStack: true });
// 		const dataFileName = activity.contentModel;
// 		const s3Data = await s3.getObject({ Bucket: env.s3.contentBucket, Key: `${getOrgId()}/mockData/${dataFileName}` }).promise();
// 		const data = JSON.parse(s3Data.Body.toString());

// 		await recursePublishActivity(activity.children, data);
// 	}
// }

// export async function recursePublishActivity(arr, data) {
// 	for (let i = 0; i < arr.length; i++) {
// 		let node = arr[i];
// 		if (node.type.startsWith("item")) {
// 			if (node.hasOwnProperty("commentsTemplate") && node.commentsTemplate !== "") {
// 				// Go to s3 and get template
// 				const s3 = new AWS.S3({ useDualStack: true });

// 				const sourceFileName = node.commentsTemplate;
// 				const s3Source = await s3.getObject({ Bucket: env.s3.contentBucket, Key: `${getOrgId()}/templates/activity/${sourceFileName}` }).promise();
// 				const source = s3Source.Body.toString();
// 				// Used in eval
// 				let contentModel = data; //eslint-disable-line
// 				let newData = null; //eslint-disable-line
// 				if (node.hasOwnProperty("commentsDataPath") && node.commentsDataPath !== "") { //eslint-disable-line
// 					// For security reasons should only allow paths to be selected
// 					newData = eval(node.commentsDataPath); //eslint-disable-line
// 				} //eslint-disable-line

// 				const mergedTemplate = mergeTemplate(source, newData);
// 				arr[i].comments = mergedTemplate;
// 			}
// 		}

// 		if (arr[i].hasOwnProperty("children")) {
// 			await recursePublishActivity(arr[i].children, data);
// 		}
// 	}
// }

// function mergeTemplate(source, data) {
// 	let template = Handlebars.compile(source);

// 	return template(data);	
// }

function speed(x, type) {
	let stripStartSquare = x.substring(7);
	let stripEndSquare = stripStartSquare.substring(0, stripStartSquare.length - 1);
	let speeds = stripEndSquare.split(";");

	if (type === "MPH") {
		return speeds[1] + " MPH";
	} else {
		return speeds[0] + " KIAS";
	}
}

export function recurseReplaceSpeeds(arr) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type.startsWith("item")) {
			arr[i].label1 = arr[i].label1.replace(/\[speed [^]+;[^]+\]/g, function myFunction(x) { return speed(x, "KIAS"); });
			arr[i].label2 = arr[i].label2.replace(/\[speed [^]+;[^]+\]/g, function myFunction(x) { return speed(x, "KIAS"); });
		}

		if (arr[i].hasOwnProperty("children")) {
			recurseReplaceSpeeds(arr[i].children);
		}
	}
}

export function preloadImages(arr) {
	console.log("preloadImages");

	for (let i = 0; i < arr.length; i++) {
		if (arr[i].hasOwnProperty("image")) {
			const hasImage = itemHasImage(arr[i]);

			if (hasImage) {
				const img = new Image();
				const url = getUrlForValue(arr[i].image, getSelectedActivityId());
				img.src = url;	
			}
		}

		if (arr[i].hasOwnProperty("children")) {
			preloadImages(arr[i].children);
		}
	}
}

export function clearAppState(tree) {
	tree.set(["appState","sectionsMenuVisible"],false);
}

export function recurseToFlatArray(arr, lastList, lastSection, resArr) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			lastList = {
				list: arr[i].name
			};
		} else if (arr[i].type === "section") {
			lastSection = {
				section: arr[i].name
			};
		} else if (arr[i].type.startsWith("item")) {
			let arrNode = [];
			if (lastList !== "") {
				arrNode.push("\"" + lastList.list.replace(/"/g, "\"\"") + "\"");
			} else {
				arrNode.push("\"Sections\"");
			}
			if (lastSection !== "") {
				arrNode.push("\"" + lastSection.section.replace(/"/g, "\"\"") + "\"");
			} else {
				arrNode.push("\"Items\"");
			}
			arrNode.push("\"" + arr[i].label1.replace(/"/g, "\"\"") + "\"");
			arrNode.push("\"" + arr[i].label2.replace(/"/g, "\"\"") + "\"");
			arrNode.push(arr[i].labelOnly);
			arrNode.push(arr[i].labelOnlyBackgroundColor);
			arrNode.push(arr[i].mandatory);

			resArr.push(arrNode);
		}

		if (arr[i].hasOwnProperty("children")) {
			recurseToFlatArray(arr[i].children, lastList, lastSection, resArr);
		}
	}
}


// export function recurseToFlatArrayAdvanced(activity, arr, lastList, lastSection, resArr) {
// 	for (let i = 0; i < arr.length; i++) {
// 		if (arr[i].type === "list") {
// 			lastList = {
// 				id: arr[i].hasOwnProperty("id") ? arr[i].id : "",
// 				list: arr[i].name,
// 				listAudio: arr[i].hasOwnProperty("nameAudio") ? arr[i].nameAudio : "",
// 				listPrint: arr[i].hasOwnProperty("namePrint") ? arr[i].namePrint : "",
// 				defaultView: arr[i].hasOwnProperty("defaultView") ? arr[i].defaultView : "checklistView",
// 				color: arr[i].hasOwnProperty("color") ? arr[i].color : "",
// 				ignoreCompletion: arr[i].ignoreCompletion,
// 				dontPrint: arr[i].suppressPrint
// 			};
// 		} else if (arr[i].type === "section") {
// 			lastSection = {
// 				id: arr[i].hasOwnProperty("id") ? arr[i].id : "",
// 				section: arr[i].name,
// 				sectionAudio: arr[i].hasOwnProperty("nameAudio") ? arr[i].nameAudio : "",
// 				sectionPrint: arr[i].hasOwnProperty("namePrint") ? arr[i].namePrint : "",
// 				color: arr[i].hasOwnProperty("color") ? arr[i].color : "",
// 				iconColor: arr[i].hasOwnProperty("iconColor") ? arr[i].iconColor : "",
// 				backgroundColor: arr[i].hasOwnProperty("backgroundColor") ? arr[i].backgroundColor : "",
// 				borderColor: arr[i].hasOwnProperty("borderColor") ? arr[i].borderColor : "",
// 				ignoreCompletion: arr[i].ignoreCompletion,
// 				dontPrint: arr[i].suppressPrint
// 			};
// 		} else if (arr[i].type.startsWith("item")) {
// 			let node = {
// 				list: lastList === "" ? "" : lastList.list,
// 				section: lastSection === "" ? "" : lastSection.section,
// 				id: arr[i].hasOwnProperty("id") ? arr[i].id : "",
// 				type: arr[i].hasOwnProperty("type") ? arr[i].type : "",
// 				label1: arr[i].label1,
// 				label2: arr[i].label2,
// 				comments: arr[i].comments,
// 				commentsInline: arr[i].hasOwnProperty("commentsInline") ? arr[i].commentsInline : "",
// 				mandatory: arr[i].mandatory,
// 				ignoreCompletion: arr[i].ignoreCompletion,
// 				labelOnly: arr[i].labelOnly,
// 				labelOnlyBackgroundColor: arr[i].labelOnlyBackgroundColor,
// 				label1Color: arr[i].hasOwnProperty("color") ? arr[i].color : "",
// 				label1Audio: arr[i].hasOwnProperty("label1Audio") ? arr[i].label1Audio : "",
// 				label1Print: arr[i].hasOwnProperty("label1Print") ? arr[i].label1Print : "",
// 				label2Color: arr[i].hasOwnProperty("label2Color") ? arr[i].label2Color : "",
// 				label2Audio: arr[i].hasOwnProperty("label2Audio") ? arr[i].label2Audio : "",
// 				label2Print: arr[i].hasOwnProperty("label2Print") ? arr[i].label2Print : "",

// 				textInputPlaceholder: arr[i].hasOwnProperty("textInputPlaceholder") ? arr[i].textInputPlaceholder : "",
// 				textInputDefaultValue: arr[i].hasOwnProperty("textInputDefaultValue") ? arr[i].textInputDefaultValue : "",
// 				textInputMaxLength: arr[i].hasOwnProperty("textInputMaxLength") ? arr[i].textInputMaxLength : "",
// 				textInputKeyboardType: arr[i].hasOwnProperty("textInputKeyboardType") ? arr[i].textInputKeyboardType : "",
// 				textInputKeyboardAutoCapitalize: arr[i].hasOwnProperty("textInputKeyboardAutoCapitalize") ? arr[i].textInputKeyboardAutoCapitalize : "",
// 				textInputKeyboardAutoCorrect: arr[i].textInputKeyboardAutoCorrect,
// 				textInputKeyboardReturnKeyType: arr[i].hasOwnProperty("textInputKeyboardReturnKeyType") ? arr[i].textInputKeyboardReturnKeyType : "",
// 				textInputMaskType: arr[i].hasOwnProperty("textInputMaskType") ? arr[i].textInputMaskType : "",
// 				textInputCurrencySymbol: arr[i].hasOwnProperty("textInputCurrencySymbol") ? arr[i].textInputCurrencySymbol : "",
// 				textInputCurrencySeparator: arr[i].hasOwnProperty("textInputCurrencySeparator") ? arr[i].textInputCurrencySeparator : "",
// 				textInputNumberOfLines: arr[i].hasOwnProperty("textInputNumberOfLines") ? arr[i].textInputNumberOfLines : "",

// 				pickerItemViewType: arr[i].hasOwnProperty("pickerItemViewType") ? arr[i].pickerItemViewType : "",
// 				pickerItemsDatasource: arr[i].hasOwnProperty("pickerItemsDatasource") ? _.omit(arr[i].pickerItemsDatasource, ["content"]) : "",
// 				itemsDatasource: arr[i].hasOwnProperty("itemsDatasource") ? _.omit(arr[i].itemsDatasource, ["content"]) : "",
// 				config: arr[i].hasOwnProperty("config") ? arr[i].config : {},
// 				pickerItemPlaceholder: arr[i].hasOwnProperty("pickerItemPlaceholder") ? arr[i].pickerItemPlaceholder : "",
// 				pickerItemDefaultValue: arr[i].hasOwnProperty("pickerItemDefaultValue") ? arr[i].pickerItemDefaultValue : "",
// 				pickerItems: arr[i].hasOwnProperty("pickerItems") ? arr[i].pickerItems : "",
// 				pickerAdvanceOnSelect: arr[i].pickerAdvanceOnSelect,
// 				pickerLinkOnSelect: arr[i].pickerLinkOnSelect,
// 				pickerLinkActionType: arr[i].hasOwnProperty("pickerLinkActionType") ? arr[i].pickerLinkActionType : "",

// 				yesNoLinkOnSelect: arr[i].yesNoLinkOnSelect,
// 				yesNoLinkActionType: arr[i].hasOwnProperty("yesNoLinkActionType") ? arr[i].yesNoLinkActionType : "",
// 				yesNoYesLinkId: arr[i].hasOwnProperty("yesNoYesLinkId") ? arr[i].yesNoYesLinkId : "",
// 				yesNoNoLinkId: arr[i].hasOwnProperty("yesNoNoLinkId") ? arr[i].yesNoNoLinkId : "",
// 				yesNoNaLinkId: arr[i].hasOwnProperty("yesNoNaLinkId") ? arr[i].yesNoNaLinkId : "",
// 				yesNoShowNa: arr[i].yesNoShowNa,

// 				dateTimeType: arr[i].hasOwnProperty("dateTimeType") ? arr[i].dateTimeType : "",
// 				dateTimeInitialDate: arr[i].hasOwnProperty("dateTimeInitialDate") ? arr[i].dateTimeInitialDate : "",
// 				dateTimeMinuteInterval: arr[i].hasOwnProperty("dateTimeMinuteInterval") ? arr[i].dateTimeMinuteInterval : "",

// 				imagePickerAddMediaButton: arr[i].hasOwnProperty("imagePickerAddMediaButton") ? arr[i].imagePickerAddMediaButton : "",
// 				imagePickerUploadTitle: arr[i].hasOwnProperty("imagePickerUploadTitle") ? arr[i].imagePickerUploadTitle : "",
// 				imagePickerCaptureMediaTitle: arr[i].hasOwnProperty("imagePickerCaptureMediaTitle") ? arr[i].imagePickerCaptureMediaTitle : "",

// 				sketchPadBackgroundColor: arr[i].hasOwnProperty("sketchPadBackgroundColor") ? arr[i].sketchPadBackgroundColor : "",
// 				sketchPadPenColor: arr[i].hasOwnProperty("sketchPadPenColor") ? arr[i].sketchPadPenColor : "",
// 				sketchPadPenWidth: arr[i].hasOwnProperty("sketchPadPenWidth") ? arr[i].sketchPadPenWidth : "",

// 				dontPrint: arr[i].suppressPrint,
// 				startTimer: arr[i].startTimer,
// 				stopTimer: arr[i].stopTimer,

// 				linkOnCheck: arr[i].linkOnCheck,
// 				linkId: arr[i].hasOwnProperty("linkId") ? arr[i].linkId : "",
// 				linkActionType: arr[i].hasOwnProperty("linkActionType") ? arr[i].linkActionType : ""
// 			};

// 			let arrNode = [];

// 			let tags = JSON.stringify(activity.tags);

// 			arrNode.push(formatQuotes((activity.hasOwnProperty("activityId") ? activity.activityId : "")));
// 			arrNode.push(formatQuotes(activity.name));
// 			arrNode.push(formatQuotes(activity.nameAudio));
// 			arrNode.push(formatQuotes(activity.namePrint));
// 			arrNode.push(formatQuotes(activity.description));
// 			arrNode.push(activity.suppressAudio);
// 			arrNode.push(formatQuotes(activity.genre));
// 			arrNode.push(tags);

// 			if (lastList !== "") {
// 				arrNode.push(formatQuotes(lastList.id));
// 				arrNode.push(formatQuotes(lastList.list));
// 				arrNode.push(formatQuotes(lastList.listAudio));
// 				arrNode.push(formatQuotes(lastList.listPrint));
// 				arrNode.push(lastList.defaultView);
// 				arrNode.push(lastList.color);
// 				arrNode.push(lastList.ignoreCompletion);
// 				arrNode.push(lastList.dontPrint);
// 			} else {
// 				arrNode.push("");
// 				arrNode.push(formatQuotes("Sections"));
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 			}


// 			if (lastSection !== "") {
// 				arrNode.push(formatQuotes(lastSection.id));
// 				arrNode.push(formatQuotes(lastSection.section));
// 				arrNode.push(formatQuotes(lastSection.sectionAudio));
// 				arrNode.push(formatQuotes(lastSection.sectionPrint));
// 				arrNode.push(lastSection.color);
// 				arrNode.push(lastSection.iconColor);
// 				arrNode.push(lastSection.backgroundColor);
// 				arrNode.push(lastSection.borderColor);
// 				arrNode.push(lastSection.ignoreCompletion);
// 				arrNode.push(lastSection.dontPrint);
// 			} else {
// 				arrNode.push("");
// 				arrNode.push(formatQuotes("Items"));
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 				arrNode.push("");
// 			}

// 			arrNode.push(formatQuotes(node.id));
// 			arrNode.push(formatQuotes(node.type));
// 			arrNode.push(formatQuotes(node.label1));
// 			arrNode.push(formatQuotes(node.label2));
// 			arrNode.push(formatQuotes(node.comments));
// 			arrNode.push(node.commentsInline);
// 			arrNode.push(node.mandatory);
// 			arrNode.push(node.ignoreCompletion);
// 			arrNode.push(node.labelOnly);
// 			arrNode.push(node.labelOnlyBackgroundColor);
// 			arrNode.push(node.label1Color);
// 			arrNode.push(formatQuotes(node.label1Audio));
// 			arrNode.push(formatQuotes(node.label1Print));
// 			arrNode.push(node.label2Color);
// 			arrNode.push(formatQuotes(node.label2Audio));
// 			arrNode.push(formatQuotes(node.label2Print));

// 			arrNode.push(formatQuotes(node.textInputPlaceholder));
// 			arrNode.push(formatQuotes(node.textInputDefaultValue));
// 			arrNode.push(node.textInputMaxLength);
// 			arrNode.push(formatQuotes(node.textInputKeyboardType));
// 			arrNode.push(formatQuotes(node.textInputKeyboardAutoCapitalize));
// 			arrNode.push(node.textInputKeyboardAutoCorrect);
// 			arrNode.push(formatQuotes(node.textInputKeyboardReturnKeyType));
// 			arrNode.push(formatQuotes(node.textInputMaskType));
// 			arrNode.push(formatQuotes(node.textInputCurrencySymbol));
// 			arrNode.push(formatQuotes(node.textInputCurrencySeparator));
// 			arrNode.push(node.textInputNumberOfLines);

// 			arrNode.push(formatQuotes(node.pickerItemViewType));
// 			arrNode.push(formatQuotes(node.pickerItemsDatasource));
// 			arrNode.push(formatQuotes(node.itemsDatasource));
// 			arrNode.push(formatQuotes(node.config));
// 			arrNode.push(formatQuotes(node.pickerItemPlaceholder));
// 			arrNode.push(formatQuotes(node.pickerItemDefaultValue));
// 			arrNode.push(formatQuotesForObject(node.pickerItems));
// 			arrNode.push(node.pickerAdvanceOnSelect);
// 			arrNode.push(node.pickerLinkOnSelect);
// 			arrNode.push(formatQuotes(node.pickerLinkActionType));

// 			arrNode.push(node.yesNoLinkOnSelect);
// 			arrNode.push(formatQuotes(node.yesNoLinkActionType));
// 			arrNode.push(formatQuotes(node.yesNoYesLinkId));
// 			arrNode.push(formatQuotes(node.yesNoNoLinkId));
// 			arrNode.push(formatQuotes(node.yesNoNaLinkId));
// 			arrNode.push(node.yesNoShowNa);

// 			arrNode.push(formatQuotes(node.dateTimeType));
// 			arrNode.push(formatQuotes(node.dateTimeInitialDate));
// 			arrNode.push(formatQuotes(node.dateTimeMinuteInterval));

// 			arrNode.push(formatQuotes(node.imagePickerAddMediaButton));
// 			arrNode.push(formatQuotes(node.imagePickerUploadTitle));
// 			arrNode.push(formatQuotes(node.imagePickerCaptureMediaTitle));

// 			arrNode.push(node.sketchPadBackgroundColor);
// 			arrNode.push(node.sketchPadPenColor);
// 			arrNode.push(node.sketchPadPenWidth);

// 			arrNode.push(node.dontPrint);
// 			arrNode.push(node.startTimer);
// 			arrNode.push(node.stopTimer);

// 			arrNode.push(node.linkOnCheck);
// 			arrNode.push(formatQuotes(node.linkId));
// 			arrNode.push(formatQuotes(node.linkActionType));

// 			resArr.push(arrNode);
// 		}

// 		if (arr[i].hasOwnProperty("children")) {
// 			recurseToFlatArrayAdvanced(activity, arr[i].children, lastList, lastSection, resArr);
// 		}
// 	}
// }

// function formatQuotes(str) {
// 	return "\"" + str.replace(/"/g, "\"\"") + "\"";
// }

// function formatQuotesForObject(obj) {
// 	if (_.isEmpty(obj)) {
// 		return "";
// 	} else {
// 		return "\"" + JSON.stringify(obj).replace(/"/g, "\"\"") + "\"";
// 	}
// }

// export function createBlobCsv2(csvData, exportFilename) {
// 	const blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
// 	FileSaver.saveAs(blob, exportFilename);
// }

export function createMarkup(label, columns) {
	let myRenderer = new marked.Renderer();

	let width = "240";
	let height = "180";

	if (columns) {
		width = "120";
		height = "90";
	}

	myRenderer.link = function (href, title, text) {
		let external, newWindow, out;
		external = /^https?:\/\/.+$/.test(href);
		newWindow = external || title === "newWindow";
		out = "<a href=\"" + href + "\"";
		if (newWindow) {
			out += " target=\"_blank\"";
		}
		if (title && title !== "newWindow") {
			out += " title=\"" + title + "\"";
		}
		return out += ">" + text + "</a>";
	};

	myRenderer.image = function (href, title, text) {
		return "<img src=\"" + href + "\" width=\"" + width + "\" height=\"" + height + "\" /><br/><div>" + text + "</div>";
	};

	// myRenderer.paragraph = function (text) {
	// 	return text;
	// };

	marked.setOptions({
		renderer: myRenderer,
		gfm: true,
		tables: true,
		breaks: true,
		pedantic: false,
		sanitize: false,
		smartLists: true,
		smartypants: false
	});

	return marked(label);
}


export function createMarkupForComments(comments) {
	let myRenderer = new marked.Renderer();
	myRenderer.link = function (href, title, text) {
		let external, newWindow, out;
		external = /^https?:\/\/.+$/.test(href);
		newWindow = external || title === "newWindow";
		out = "<a href=\"" + href + "\"";
		if (newWindow) {
			out += " target=\"_blank\"";
		}
		if (title && title !== "newWindow") {
			out += " title=\"" + title + "\"";
		}
		return out += ">" + text + "</a>";
	};

	myRenderer.image = function (href, title, text) {
		return "<img style=\"max-width: 100%\" src=\"" + href + "\" /><br/><div>" + text + "</div>";
	};

	// myRenderer.paragraph = function (text) {
	// 	return text;
	// };

	marked.setOptions({
		renderer: myRenderer,
		gfm: true,
		tables: true,
		breaks: true,
		pedantic: false,
		sanitize: false,
		smartLists: true,
		smartypants: false
	});

	return marked(comments);
}

export function recurseConvertActivityToMarkdown(arr, columns) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type.startsWith("item")) {
			arr[i].label1 = createMarkup(arr[i].label1, columns);
			arr[i].label2 = createMarkup(arr[i].label2, columns);
		}

		if (arr[i].hasOwnProperty("children")) {
			recurseConvertActivityToMarkdown(arr[i].children, columns);
		}
	}
}

export function recurseExtractNotes(arr, notes, lastListIndex, lastSectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			lastListIndex = i;
		} else if (arr[i].type === "section") {
			lastSectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			if (arr[i].hasOwnProperty("notes")) {
				if (arr[i].notes !== "") {
					notes.push(
						{
							listIndex: lastListIndex,
							sectionIndex: lastSectionIndex,
							itemIndex: i,
							label1: arr[i].label1,
							label2: arr[i].label2,
							notes: arr[i].notes
						}
					);
				}
			}

			if (arr[i].hasOwnProperty("mediaAttachmentsUrls") && arr[i].mediaAttachmentsUrls.length > 0) {
				notes.push(
					{
						listIndex: lastListIndex,
						sectionIndex: lastSectionIndex,
						itemIndex: i,
						label1: arr[i].label1,
						label2: arr[i].label2,
						mediaAttachmentsUrls: arr[i].mediaAttachmentsUrls
					}
				);
			}
		}

		if (arr[i].hasOwnProperty("children")) {
			recurseExtractNotes(arr[i].children, notes, lastListIndex, lastSectionIndex);
		}
	}
}

export function getIconForType(type) {
	let icon = "";

	state.get(["itemTypes"]).forEach(itemType => {
		if (itemType.type === type) {
			icon = itemType.icon;
		}
	});

	return icon;
}

export function getGenreIconForType(tree, type) {
	let genres = tree.get(["genres"]);

	for (let i = 0; i < genres.length; i++) {
		let genre = genres[i];
		if (type === genre.value) {
			return genre.icon;
		}
	}

	return "check-square";
}

export function getAdditionalInfoComponent(entity) {
	let additionalInfo = null;
	let additionalInfoComponents = [];
	if (entity.id && !_.isEmpty(entity.id)) {
		additionalInfoComponents.push(<div className="id-info" key={`id-view-${entity.id}`} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }} title={`ID: ${entity.id} (Can be used for conditions and calculations)`}><b>ID:</b>&nbsp;{entity.id}</div>);
	}

	if (entity.conditionalVisible && !_.isEmpty(entity.conditionalVisible)) {
		additionalInfoComponents.push(<div className="cond-visible-info" key={`cond-visible-view-${entity.id}`} title="Conditional Visibility"><FontAwesomeIcon icon="eye" /></div>);
	}

	if (entity.groupNames && !_.isEmpty(entity.groupNames)) {
		const groupsNames = _.join(entity.groupNames, ", ");
		additionalInfoComponents.push(<div className="group-info" key={`group-view-${entity.id}`} title={`Member of groups: ${groupsNames}`}><b>Groups:</b>&nbsp;{groupsNames}</div>);
	}

	if (!_.isEmpty(additionalInfoComponents)) {
		additionalInfo = (
			<div className="additional-info">
				{additionalInfoComponents}
			</div>
		);
	}
	return additionalInfo;
}

export function convertValueToMoney(value, currencySymbol, currencySeparator) {
	if (_.isUndefined(value)) { return value; }
	value = value.split(currencySymbol).join("");
	value = value.replace(/\D/g, "");
	value = currencySymbol + value.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1" + currencySeparator);
	return value;
}

export function convertValueToPhoneNumber(value) {
	if (_.isUndefined(value)) { return value; }
	value = value.replace(/\D/g, "");
	value = value.replace(/^(\d\d\d)(\d)/g, "($1) $2");
	value = value.replace(/(\d{3})(\d)/, "$1-$2");
	return value;
}

export function getExtension(path) {
	const pathParts = path.split(".");
	if (pathParts.length === 1) {
		return "";
	} else {
		return pathParts[pathParts.length - 1].toLowerCase();
	}
}

export function isVideo(path) {
	if (isVideoMov(path) || isVideoMp4(path)) {
		return true;
	} else {
		return false;
	}
}

export function isVideoMov(path) {
	const ext = getExtension(path);
	if (ext === "mov") {
		return true;
	} else {
		return false;
	}
}

export function isVideoMp4(path) {
	const ext = getExtension(path);
	if (ext === "mp4") {
		return true;
	} else {
		return false;
	}
}

export function convertGoogleMapPlaceToValue(place) {

	let value = {};

	let addressComponents = {};

	_.each(place.address_components, (addressComponent) => {
		addressComponents[addressComponent.types[0]] = addressComponent.long_name;
	});

	value.address_components = addressComponents;

	if (place.formatted_address) { value.address = place.formatted_address; }
	if (place.formatted_phone_number) { value.phoneNumber = place.formatted_phome_number; }

	let lngLat = place.geometry.location;

	value.longitude = lngLat.lng();
	value.latitude = lngLat.lat();

	let viewport = place.geometry.viewport;
	if (viewport) {
		value.south = viewport.south;
		value.west = viewport.west;
		value.north = viewport.north;
		value.east = viewport.east;
	}


	if (place.icon) { value.icon = place.icon; }
	if (place.id) { value.id = place.id; }
	if (place.international_phone_number) { place.internationalPhoneNumber = place.international_phone_number; }
	if (place.name) { value.name = place.name; }
	if (place.place_id) { value.placeID = place.place_id; }
	if (place.plus_code) { value.plusCode = place.plus_code; }
	if (place.price_level) { value.priceLevel = place.price_level; }
	if (place.rating) { value.rating = place.rating; }
	if (place.reference) { value.reference = place.reference; }
	if (place.scope) { value.scope = place.scope; }
	if (place.types) { value.types = place.types; }
	if (place.url) { value.url = place.url; }
	if (place.utc_offset) { value.utcOffset = place.utc_offset; }
	if (place.vicinity) { value.vicinity = place.vicinity; }
	if (place.website) { value.website = place.website; }

	return value;
}

export function getLocationValueString(location) {
	let value = "";
	if (!_.isUndefined(location) && location !== null) {
		if (location.hasOwnProperty("name") && location.hasOwnProperty("address")) {
			value = location.name + "<br/>" + location.address;
		} else if (location.hasOwnProperty("address")) {
			value = location.address;
		} else if (location.hasOwnProperty("name")) {
			value = location.name;
		} else if (location.hasOwnProperty("latitude")) {
			value = "Latitude: " + location.latitude + "<br/>Longitude: " + location.longitude;
		} else if (location !== "") {
			//value = stateValue + "";
		} else {
			value = "No location";
		}
	}

	return value;
}

export function getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex) {
	return [listIndex, sectionIndex, itemIndex].join(",");
}

export function mcMoment(item, initial = null) {
	if (hasDateTimeUtc(item)) {
		if (initial !== null) {
			return moment.utc(initial);
		} else {
			return moment().utc();
		}
	} else {
		if (initial !== null) {
			return moment(initial);
		} else {
			return moment();
		}
	}
}

export function getDateMode(type) {
	if (type.toLowerCase() === "itemdate") {
		return "date";
	} else if (type.toLowerCase() === "itemtime") {
		return "time";
	} else if (type.toLowerCase() === "itemdatetime") {
		return "datetime";
	}
}

export function hasDateTimeUtc(item) {
	return item.hasOwnProperty("dateTimeType") && item.dateTimeType === "utc";
}

export function captureQueryString() {
	const queryString = qs.parse(window.location.search, { ignoreQueryPrefix: true });
	const _queryString = {};
	_.forEach(queryString, (value, key) => {
		_queryString[key] = castit(value);
	});
	// console.log("CAPTURED QUERY STRING", _queryString);
	state.set(["queryString"], _queryString);
}

export function getQueryStringParam(key) {
	return state.get(["queryString", key]);
}


export function getFileTypeIcon(ext) {
	let result = "file-text";
	switch (_.toLower(ext)) {
		case "jpg":
		case "jpeg":
		case "gif":
		case "tiff":
		case "png":
		case "svg": {
			result = "file-image-o";
			break;
		}
		case "hbs":
		case "html":
		case "xml":
		case "json": {
			result = "file-code-o";
			break;
		}
		case "mp4":
		case "mpeg": {
			result = "file-video-o";
			break;
		}
		case "mp3":
		case "wav": {
			result = "file-audio-o";
			break;
		}
		case "xlsx":
		case "xls": {
			result = "file-excel-o";
			break;
		}
		case "doc":
		case "docx": {
			result = "file-word-o";
			break;
		}
		case "pdf":
		case "tex": {
			result = "file-pdf-o";
			break;
		}
		default: {
			result = "file-o";
		}
	}
	return result;
}

export function getNodeType(node) {
	return node.children ? node.root ? "root" : "folder" : "file";
}

export function validateUrl(value) {

	const _value = value.replace(/ /g, "%20");

	return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(_value);
}

export function handleOpenInNewTab(url) {
	let win = window.open(url, "_blank");
	win.focus();
}
export function isVisible(node, skipResolve = false) {
	let obj = skipResolve ? node : getObjectByGuid(node.guid, node);
	return !obj.hasOwnProperty("visible") || obj.visible;
}

export function getActivityLastUpdatedDateTime(activity) {
	return activity.history.length > 0 ? Math.round(moment.utc(activity.history[activity.history.length - 1].timestamp).valueOf() / 1000) : 0;
}

export function getActivityPath(identityId, activity) {
	let lastTimestamp = (activity.history[0].timestamp).replace(" ", "T");
	let fileName = identityId + "/" + activity.id + "/" + lastTimestamp + "_" + activity.instanceId + ".json";
	return fileName;
}

export function createActivitySessionListItem(activity, params = {}) {
	const { submit, submitted } = params;
	let session = {
		"objectID": activity.instanceId,
		"id": activity.id,
		"activityId": activity.activityId,
		"instanceId": activity.instanceId,
		"displayName": activity.displayName,
		"name": activity.name,
		"description": activity.description,
		"items": [],
		"genre": activity.genre,
		"tags": activity.tags,
		"url": getActivityPath(state.get(["user", "identityId"]), activity),
		"createdDateTime": Math.round(moment.utc(activity.history[0].timestamp).valueOf() / 1000),
		"lastUpdatedDateTime": getActivityLastUpdatedDateTime(activity)
	};
	if (submit) {
		// console.log("SUBMITTED", params);
		session.submitted = submitted;
	}
	return session;
}

export function findNodeById(tree, id) {
	// const cacheKey = `id:${id}`;
	// if (this.pathCache[cacheKey]) {
	// 	const path = this.pathCache[cacheKey];
	// 	return {
	// 		node: tree.get(path),
	// 		path
	// 	}
	// } else {
	findNode = null;
	let lists = tree.get(PlayerPaths.ACTIVITY_LISTS);
	findNodeByIdRecurse(id, lists, tree, 0, 0);
	// if (this.findNode && !_.isEmpty(this.findNode.path)) {
	// 	// Cache it
	// 	this.pathCache[cacheKey] = this.findNode.path;
	// }
	//}	
}


export function findNodeByIdRecurse(id, arr, tree, listIndex, sectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			if (arr[i].id !== null && arr[i].id === id && !_.isUndefined(arr[i].id)) {
				findNode = {
					node: tree.get(PlayerPaths.ACTIVITY_LIST(i)),
					path: PlayerPaths.ACTIVITY_LIST(i)
				};
			}
			listIndex = i;
		} else if (arr[i].type === "section") {
			if (arr[i].id !== null && arr[i].id === id && !_.isUndefined(arr[i].id)) {
				findNode = {
					node: tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, i)),
					path: PlayerPaths.ACTIVITY_SECTION(listIndex, i)
				};
			}
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			if (arr[i].id !== null && arr[i].id === id && !_.isUndefined(arr[i].id)) {
				findNode = {
					node: tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, i)),
					path: PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, i)
				};
			}
		}

		if (arr[i].hasOwnProperty("children")) {
			findNodeByIdRecurse(id, arr[i].children, tree, listIndex, sectionIndex);
		}
	}
}

// export function getRealName(name) {
// 	var names = name.split("|");

// 	return names[0].trim();
// }

export function findNodeByGuid(tree, guid) {
	const cacheKey = `guid:${guid}`;
	if (pathCache[cacheKey]) {
		const path = pathCache[cacheKey];
		findNode = {
			node: tree.get(path),
			path
		};
		return findNode;
	} else {
		findNode = null;
		let lists = tree.get(PlayerPaths.ACTIVITY_LISTS);
		findNodeByGuidRecurse(guid, lists, tree, 0, 0);
		if (findNode && !_.isEmpty(findNode.path)) {
			// Cache it
			const { path } = findNode;
			pathCache[cacheKey] = path;
			this.findNode = {
				node: tree.get(path),
				path
			};
			return this.findNode;
		}
	}

}

export function findNodeByGuidRecurse(guid, arr, tree, listIndex, sectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			if (arr[i].guid !== null && arr[i].guid === guid) {
				findNode = {
					node: tree.get(PlayerPaths.ACTIVITY_LIST(i)),
					path: PlayerPaths.ACTIVITY_LIST(i)
				};
			}
			listIndex = i;
		} else if (arr[i].type === "section") {
			if (arr[i].guid !== null && arr[i].guid === guid) {
				findNode = {
					node: tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, i)),
					path: PlayerPaths.ACTIVITY_SECTION(listIndex, i)
				};
			}
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			if (arr[i].guid !== null && arr[i].guid === guid) {
				findNode = {
					node: tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, i)),
					path: PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, i)
				};
			}
		}

		if (arr[i].hasOwnProperty("children")) {
			findNodeByGuidRecurse(guid, arr[i].children, tree, listIndex, sectionIndex);
		}
	}
}

export function getLastFoundNode() {
	//TODO: put in baobab
	return findNode;
}

//TODO: Put these in own utils

export function initializeIdsAndVariableState(tree) {
	if (!tree.exists(PlayerPaths.ACTIVITY_VARIABLES)) {
		tree.set(PlayerPaths.ACTIVITY_VARIABLES, {});
	}
	if (!tree.exists(PlayerPaths.ACTIVITY_VARIABLE_GROUPS)) {
		tree.set(PlayerPaths.ACTIVITY_VARIABLE_GROUPS, {});
	}
	if (!tree.exists(PlayerPaths.ACTIVITY_OVERRIDES)) {
		tree.set(PlayerPaths.ACTIVITY_OVERRIDES, {});
	}
	let lists = tree.get(PlayerPaths.ACTIVITY_LISTS);
	initializeIdsAndVariableStateRecurse(lists, tree, 0, 0);
}

export function initializeIdsAndVariableStateRecurse(arr, tree, listIndex, sectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
			if (!tree.get(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "guid"))) {
				const listCursor = tree.select(PlayerPaths.ACTIVITY_LIST(listIndex));
				const currentId = listCursor.get(["id"]);
				const currentGuid = listCursor.get(["guid"]);
				const targetGuid = currentGuid && !_.isEmpty(_.trim(currentGuid)) ? currentGuid : currentId && !_.isEmpty(_.trim(currentId)) ? currentId : generateUUID();
				if (!tree.exists(PlayerPaths.ACTIVITY_OVERRIDE(targetGuid))) {
					tree.set(PlayerPaths.ACTIVITY_OVERRIDE(targetGuid), {});
				}
				tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "guid"), targetGuid);
			}
		} else if (arr[i].type === "section") {
			sectionIndex = i;
			if (!tree.get(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "guid"))) {
				const sectionCursor = tree.select(PlayerPaths.ACTIVITY_SECTION(listIndex, sectionIndex));
				const currentId = sectionCursor.get(["id"]);
				const currentGuid = sectionCursor.get(["guid"]);
				const targetGuid = currentGuid && !_.isEmpty(_.trim(currentGuid)) ? currentGuid : currentId && !_.isEmpty(_.trim(currentId)) ? currentId : generateUUID();
				if (!tree.exists(PlayerPaths.ACTIVITY_OVERRIDE(targetGuid))) {
					tree.set(PlayerPaths.ACTIVITY_OVERRIDE(targetGuid), {});
				}
				tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "guid"), targetGuid);
			}
		} else if (arr[i].type.startsWith("item")) {
			const itemCursor = tree.select(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, i));
			const currentId = itemCursor.get(["id"]);
			const currentGuid = itemCursor.get(["guid"]);
			const targetGuid = currentGuid && !_.isEmpty(_.trim(currentGuid)) ? currentGuid : currentId && !_.isEmpty(_.trim(currentId)) ? currentId : generateUUID();
			if (currentId && !tree.exists(PlayerPaths.ACTIVITY_VARIABLE(currentId))) {
				let variableValue = null;
				if (tree.exists(PlayerPaths.ACTIVITY_OVERRIDE(targetGuid))) {
					variableValue = tree.get(PlayerPaths.ACTIVITY_OVERRIDE(targetGuid));
				} else if (tree.exists(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"))) {
					variableValue = tree.get(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"));
				}
				const defaultVariable = {
					id: currentId,
					value: variableValue ? variableValue : ""
				};
				tree.set(PlayerPaths.ACTIVITY_VARIABLE(currentId), defaultVariable);
				const groupNames = itemCursor.get(["groupNames"]);
				if (groupNames && !_.isEmpty(groupNames)) {
					groupNames.forEach(groupName => {
						if (!tree.exists(PlayerPaths.ACTIVITY_VARIABLE_GROUP(groupName))) {
							tree.set(PlayerPaths.ACTIVITY_VARIABLE_GROUP(groupName), {
								[currentId]: true
							});
						} else {
							tree.set(PlayerPaths.ACTIVITY_VARIABLE_GROUP_VARIABLE(groupName, currentId), true);
						}
					});
				}
			}

			if (!tree.exists(PlayerPaths.ACTIVITY_OVERRIDE(targetGuid))) {
				if (currentId) {
					// This will leave a pointer to the actual location of the overrie
					tree.set(PlayerPaths.ACTIVITY_OVERRIDE(currentId), { targetGuid });
				}
				tree.set(PlayerPaths.ACTIVITY_OVERRIDE(targetGuid), {});
			}
			tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "guid"), targetGuid);
		}

		if (arr[i].hasOwnProperty("children")) {
			initializeIdsAndVariableStateRecurse(arr[i].children, tree, listIndex, sectionIndex);
		}
	}
}

export function populateIds(tree) {
	let lists = tree.get(PlayerPaths.ACTIVITY_PROPERTY("children"));
	populateIdsRecurse(lists, tree, 0, 0);
}

export function populateIdsRecurse(arr, tree, listIndex, sectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			if (arr[i].id !== null && arr[i].id !== "" && !_.isUndefined(arr[i].id)) {
				tree.set(["idMap", arr[i].id], { listIndex: i, sectionIndex: 0, itemIndex: 0 });
			}
			listIndex = i;
		} else if (arr[i].type === "section") {
			if (arr[i].id !== null && arr[i].id !== "" && !_.isUndefined(arr[i].id)) {
				tree.set(["idMap", arr[i].id], { listIndex: listIndex, sectionIndex: i, itemIndex: 0 });
			}
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			if (arr[i].id !== null && arr[i].id !== "" && !_.isUndefined(arr[i].id)) {
				tree.set(["idMap", arr[i].id], { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: i });
			}
		}

		if (arr[i].hasOwnProperty("children")) {
			populateIdsRecurse(arr[i].children, tree, listIndex, sectionIndex);
		}
	}
}

export function buildGroups(tree) {
	// Should clear?
	tree.set(["groups"], {});
	let lists = tree.get(PlayerPaths.ACTIVITY_PROPERTY("children"));
	buildGroupsRecurse(lists, tree, 0, 0);
}

export function buildGroupsRecurse(arr, tree, listIndex, sectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
			let groupNames = tree.get(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "groupNames"));
			addGroup(tree, groupNames, arr[i]);
		} else if (arr[i].type === "section") {
			sectionIndex = i;
			let groupNames = tree.get(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "groupNames"));
			addGroup(tree, groupNames, arr[i]);
		} else if (arr[i].type.startsWith("item")) {
			let groupNames = tree.get(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "groupNames"));
			addGroup(tree, groupNames, arr[i]);
		}

		if (arr[i].hasOwnProperty("children")) {
			buildGroupsRecurse(arr[i].children, tree, listIndex, sectionIndex);
		}
	}
}

export function addGroup(tree, groupNames, node) {
	if (groupNames && groupNames.length > 0) {
		for (let i = 0; i < groupNames.length; i++) {
			let groupName = groupNames[i];
			let group = tree.get(["groups", groupName]);
			if (group) {
				group.push(node);
			} else {
				group = [node];
			}
			tree.set(["groups", groupName], group);
		}
	}
}

export function buildFilters(tree, activity) {
	if (activity.hasOwnProperty("children")) {
		let lists = activity.children;
		if (lists.length) {
			buildFiltersRecurse(lists, tree, 0, 0);
		}
	}
}

export function buildFiltersRecurse(arr, tree, listIndex, sectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			addFilterBuild(tree, arr[i]);

			listIndex = i;

			if (arr[i].hasOwnProperty("children")) {
				buildFiltersRecurse(arr[i].children, tree, listIndex, sectionIndex);
			}
		} else if (arr[i].type === "section") {
			addFilterBuild(tree, arr[i]);

			sectionIndex = i;

			if (arr[i].hasOwnProperty("children")) {
				buildFiltersRecurse(arr[i].children, tree, listIndex, sectionIndex);
			}
		} else if (arr[i].type.startsWith("item")) {
			addFilterBuild(tree, arr[i]);
		}
	}
}

export function addFilterBuild(tree, node) {
	if (node.hasOwnProperty("filterTags") && node.filterTags.length > 0) {
		let filters = tree.get(["filters"]);
		for (let i = 0; i < node.filterTags.length; i++) {
			let inFilter = false;
			for (let j = 0; j < filters.length; j++) {
				if (filters[j].name === node.filterTags[i]) {
					inFilter = true;
				}
			}

			if (!inFilter) {
				filters.push({
					name: node.filterTags[i],
					value: true
				});
			}
		}
		tree.set(["filters"], filters);
	}
}

export function applyFilter(tree, filter, retVal) {
	retVal.dstActivity = _.cloneDeep(tree.get(PlayerPaths.ACTIVITY));
	delete retVal.dstActivity.children;

	let lists = tree.get(PlayerPaths.ACTIVITY_PROPERTY("children"));
	if (lists.length) {
		applyFilterRecurse(lists, tree, 0, null, 0, null, filter, retVal);
	}
}

export function applyFilterRecurse(arr, tree, listIndex, dstList, sectionIndex, dstSection, filter, retVal) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			let foundList = inFilter(tree, arr[i], filter);

			if (foundList) {
				if (!retVal.dstActivity.hasOwnProperty("children")) {
					retVal.dstActivity.children = [];
				}

				let dstList = _.cloneDeep(arr[i]);
				delete dstList.children;

				retVal.dstActivity.children.push(dstList);

				listIndex = i;

				if (arr[i].hasOwnProperty("children")) {
					applyFilterRecurse(arr[i].children, tree, listIndex, dstList, sectionIndex, dstSection, filter, retVal);
				}
			}
		} else if (arr[i].type === "section") {
			let foundSection = inFilter(tree, arr[i], filter);

			if (foundSection) {
				if (!dstList.hasOwnProperty("children")) {
					dstList.children = [];
				}

				let dstSection = _.cloneDeep(arr[i]);
				delete dstSection.children;

				dstList.children.push(dstSection);

				sectionIndex = i;

				if (arr[i].hasOwnProperty("children")) {
					applyFilterRecurse(arr[i].children, tree, listIndex, dstList, sectionIndex, dstSection, filter, retVal);
				}
			}
		} else if (arr[i].type.startsWith("item")) {
			let foundItem = inFilter(tree, arr[i], filter);

			if (foundItem) {
				if (!dstSection.hasOwnProperty("children")) {
					dstSection.children = [];
				}

				let dstItem = _.cloneDeep(arr[i]);

				dstSection.children.push(dstItem);
			}
		}
	}
}

export function inFilter(tree, node, filter) {
	let found = false;

	if (node.hasOwnProperty("filterTags") && node.filterTags.length > 0) {
		for (let i = 0; i < node.filterTags.length; i++) {
			// If in filter
			for (let j = 0; j < filter.length; j++) {
				if (filter[j].name === node.filterTags[i] && filter[j].value) {
					found = true;
				}
			}
		}
	} else {
		found = true;
	}

	return found;
}


export function clearPathCaches() {
	pathCache = {};
}

export function openURL(url) {
	window.open(url);
}

export function isValidItem(tree, listIndex, sectionIndex, itemIndex) {
	let currentActivity = tree.get(PlayerPaths.ACTIVITY);

	if (currentActivity.hasOwnProperty("children")) {
		if (listIndex < currentActivity.children.length) {
			if (currentActivity.children[listIndex].hasOwnProperty("children")) {
				if (sectionIndex < currentActivity.children[listIndex].children.length) {
					if (currentActivity.children[listIndex].children[sectionIndex].hasOwnProperty("children")) {
						if (itemIndex < currentActivity.children[listIndex].children[sectionIndex].children.length) {
							return true;
						}
					}
				}
			}
		}
	}

	return false;
}

export function itemHasVideo(item) {
	return item && item.hasOwnProperty("video") && item.video !== null && item.video !== "undefined" && item.video !== "";
}

export function itemHasPdf(item) {
	return item && item.hasOwnProperty("pdf") && item.pdf !== null && item.pdf !== "undefined" && item.pdf !== "";
}

export function itemHasImage(item) {
	return item && item.hasOwnProperty("image") && item.image !== null && item.image !== "undefined" && item.image !== "";
}

export function isMediaFile(file) {
	const result = file && file.type && (file.type.indexOf("image/") !== -1 || file.type.indexOf("video/") !== -1 || file.type.indexOf("audio/") !== -1);
	// console.log("Media file?", file, result);
	return result;
}

export function dataURItoBlob(dataURI, type) {
	let binary = atob(dataURI.split(",")[1]);
	let array = [];
	for (let i = 0; i < binary.length; i++) {
		array.push(binary.charCodeAt(i));
	}
	return new Blob([new Uint8Array(array)], { type: type });
}

export function isBlank(item) {
	return _.isUndefined(item) || item === null || item === "";
}

export function isInIFrame() {
	let result = false;
	try {
		// console.log(test);
		result = window.location.href !== window.top.location.href;
	} catch (e) {
		console.warn(e);
		result = true; // Cross Origin issue
	}
	return result;
}

export function getIframeAttribute(attrName) {
	let result = null;
	if (isInIFrame() && window.frameElement && window.frameElement.dataset) {
		result = window.frameElement.dataset[attrName];
	}
	return result;
}

export function handleLaunchInNewTab() {
	window.open(window.location.href.replace("autoPlay=false", ""), "_blank");
}

export function getMimeTypeFromPath(path) {
	return getMimeTypeFromExtension(getExtension(path));
}

export function getMimeTypeFromExtension(ext) {
	switch (ext) {
		case "mov":
			return "video/quicktime";
		case "mp4":
			return "video/mp4";
		case "jpg":
			return "image/jpeg";
		case "png":
			return "image/png";
		case "gif":
			return "image/gif";
		default:
			return "";
	}
}

function resolveStyles(styles) {
	let result = styles;
	if (result && result.hasOwnProperty("default")) {
		const platformOverridesProp = "webOverride";
		if (result.hasOwnProperty("web")) {
			result = result.web;
		} else if (result.hasOwnProperty(platformOverridesProp)) {
			result = _.assign({}, result.default, result[platformOverridesProp]);
		} else {
			result = result.default;
		}

	}
	return result;
}

function getStylePropFromEntity(entity, propNameStyle, defaultResult = null) {
	let result = null;
	if (entity && entity.hasOwnProperty("styles") && entity.styles[propNameStyle]) {
		const style = entity.styles[propNameStyle];
		try {
			result = style ? _.isPlainObject(style) ? style : JSON.parse(style) : defaultResult;
		} catch (e) {
			// console.warn(e);
		}
		if (!_.isPlainObject(result) || _.isEmpty(result)) {
			result = defaultResult;
		}

		// See if we have default + overrides

		result = resolveStyles(result);


	}
	return result;
}

export function getStyleAttribute(entity, overrides, propNameEntity = "styles", defaultResult = {}, activityStylesheet = null) {
	let propNamesEntity = propNameEntity;

	if (!_.isArray(propNamesEntity)) {
		propNamesEntity = [propNamesEntity];
	}
	let classStyles = {};
	const globalStylesheet = activityStylesheet ? activityStylesheet : state.get(["activity", "stylesheet"]);

	const classNames = [];
	// Classes
	if (entity.hasOwnProperty("classes")) {

		propNamesEntity.forEach(propNameEntity => {
			const result = entity.classes.hasOwnProperty(propNameEntity) ? entity.classes[propNameEntity] : null;
			if (result) {
				if (_.isString(result)) {
					classNames.push(...result.replace(/\s+/g, " ").split(" "));
				} else if (_.isArray(result)) {
					classNames.push(...result);
				}
			}
		});
	}


	if (classNames && globalStylesheet) {

		const styles = [];

		classNames.forEach(className => {
			const dotLeadingClassname = `.${className}`;
			if (globalStylesheet.hasOwnProperty(dotLeadingClassname)) {
				styles.push(resolveStyles(globalStylesheet[dotLeadingClassname]));
			}
		});

		if (styles.length > 0) {
			classStyles = _.assign({}, ...styles);
		}

	}


	const deepMergeSequence = [];
	const propNamesEntityLastIdx = propNamesEntity.length - 1;
	/**
	 * If addressing a component by its "tag name" in the global stylesheet, much like addressing for exmple an h1 in HTML.
	 */
	if (globalStylesheet) {
		propNamesEntity.forEach((propNameEntity, idx) => {
			if (globalStylesheet.hasOwnProperty(propNameEntity)) {
				const val = idx === propNamesEntityLastIdx ? resolveStyles(globalStylesheet[propNameEntity]) : _.pick(resolveStyles(globalStylesheet[propNameEntity]), HIERARCHICAL_STYLE_PROPS);
				deepMergeSequence.push(val);
			}
		});
	}

	/**
	 * If for example a list specifies a styles property that contains a "label" key then any label (label1, label2) will get that style. However according to specificity rules
	 * this can be overridden by classes, id based style assignments in global stylesheet or inline styles.
	 */
	if (overrides && _.isArray(overrides)) {
		overrides.forEach(override => {
			if (override) {
				propNamesEntity.forEach((propNameStyle, idx) => {
					if (override[propNameStyle]) {
						const val = idx === propNamesEntityLastIdx ? resolveStyles(override[propNameStyle]) : _.pick(resolveStyles(override[propNameStyle]), HIERARCHICAL_STYLE_PROPS);
						deepMergeSequence.push(val);
					}
				});
			}
		});
	}


	// Classes are more specific than cascading style overrides.
	deepMergeSequence.push(classStyles);


	// Specific Id targeets in global stylesheet
	if (entity.hasOwnProperty("id") && !_.isEmpty(entity.id) && globalStylesheet) {
		const poundLeadingId = `#${entity.id}`;
		if (globalStylesheet.hasOwnProperty(poundLeadingId)) {
			deepMergeSequence.push(resolveStyles(globalStylesheet[poundLeadingId]));
		}
	}

	// Styles in local item
	propNamesEntity.forEach((propNameStyle, idx) => {
		const _result = getStylePropFromEntity(entity, propNameStyle, defaultResult);
		const result = idx === propNamesEntityLastIdx ? _result : _.pick(_result, HIERARCHICAL_STYLE_PROPS);
		if (result) {
			deepMergeSequence.push(result);
		}
	});

	const finalDeepMergeSequence = _.filter(deepMergeSequence, o => { return _.isPlainObject(o); });

	return !_.isEmpty(finalDeepMergeSequence) ? deepmerge.all(finalDeepMergeSequence) : defaultResult;
}

const themeCache = {};

export function getThemeValue(path, defaultValue) {
	let result = defaultValue;
	if (themeCache[path]) {
		result = themeCache[path];
	} else {
		try {
			if (typeof theme !== "undefined" && !_.isUndefined(theme)) { // eslint-disable-line
				result = _.get(theme, path); // eslint-disable-line
			}
		} catch (e) {
			console.error(e);
		}

		const activityTheme = window.activityTheme;
		if (activityTheme && !_.isEmpty(activityTheme)) {
			let activityThemeResult = _.get(activityTheme, path, null);
			if (activityThemeResult) {
				result = activityThemeResult;
			}
		}

		themeCache[path] = result;
	}

	return result;
}

export function clearThemeCache() {
	deleteAllObjectKeys(themeCache);
}

/*
export function resolveAllActivityStyles(activity, theme) {
	// console.time("Calculate Styles");
	try {
		const hierarchicalActivityStyles = _.pick(getStyleAttribute(activity, [], "activity", {}), HIERARCHICAL_STYLE_PROPS);
		// const activityStylesHash = hash(activityStyles);
		const activityStylesheet = activity.stylesheet;
		// const activityStylesheetHash = hash(activityStylesheet);
		// const activityClasses = activity.classes;
		// const activityClassesHash = hash(activityClasses);

		// const theme = activity.theme;
		const itemButtonOkStyles = _.get(theme, "item.buttonOk", {});
		// const themeHash = hash(theme);
		let itemButtonOkLabel = null;
		let itemButtonOkVisibility = null;

		if (activity.itemButtonOkVisibility && !_.isEmpty(activity.itemButtonOkVisibility)) {
			itemButtonOkVisibility = activity.itemButtonOkVisibility;
		}

		if (activity.itemButtonOkLabel && !_.isEmpty(activity.itemButtonOkLabel)) {
			itemButtonOkLabel = activity.itemButtonOkLabel;
		}

		activity.children.forEach(_list => {

			if (_list.itemButtonOkVisibility && !_.isEmpty(_list.itemButtonOkVisibility)) {
				itemButtonOkVisibility = _list.itemButtonOkVisibility;
			}

			if (_list.itemButtonOkLabel && !_.isEmpty(_list.itemButtonOkLabel)) {
				itemButtonOkLabel = _list.itemButtonOkLabel;
			}

			const hierarchicalListStyles = _.pick(_list.styles, HIERARCHICAL_STYLE_PROPS);
			// const listStylesHash = hash(listStyles);
			let list = filterEmptyProps(getStyleAttribute(_list, [hierarchicalActivityStyles], ["activity", "list"], {}, activityStylesheet));
			const title = filterEmptyProps(_.pick(getStyleAttribute(_list, [hierarchicalActivityStyles], ["list", "title"]), HIERARCHICAL_STYLE_PROPS, {}, activityStylesheet));

			const additionalStyles = {};

			if (_list.hasOwnProperty("backgroundColor") && !_.isEmpty(_list.backgroundColor)) {
				additionalStyles.backgroundColor = _list.backgroundColor;
			}

			list = _.assign({}, theme.list, list, additionalStyles);

			_list.resolvedStyles = {
				list,
				title
			};
			_list.children.forEach(_section => {
				const hierarchicalSectionStyles = _.pick(_section.styles, HIERARCHICAL_STYLE_PROPS);
				// const sectionStylesHash = hash(sectionStyles);

				let section = filterEmptyProps(getStyleAttribute(_section, [hierarchicalActivityStyles, hierarchicalListStyles], ["activity", "list", "section"], {}, activityStylesheet));
				const title = filterEmptyProps(_.pick(getStyleAttribute(_section, [hierarchicalActivityStyles, hierarchicalListStyles], ["section", "title"], {}, activityStylesheet), HIERARCHICAL_STYLE_PROPS));
				const additionalStyles = {};

				if (_section.hasOwnProperty("backgroundColor") && !_.isEmpty(_section.backgroundColor)) {
					additionalStyles.backgroundColor = _section.backgroundColor;
				}

				section = _.assign({}, theme.section, section, additionalStyles);

				_section.resolvedStyles = {
					section,
					title
				};

				if (_section.itemButtonOkVisibility && !_.isEmpty(_section.itemButtonOkVisibility)) {
					itemButtonOkVisibility = _section.itemButtonOkVisibility;
				}

				if (_section.itemButtonOkLabel && !_.isEmpty(_section.itemButtonOkLabel)) {
					itemButtonOkLabel = _section.itemButtonOkLabel;
				}

				_section.children.forEach(_item => {

					let item = filterEmptyProps(getStyleAttribute(_item, [hierarchicalActivityStyles, hierarchicalListStyles, hierarchicalSectionStyles], ["activity", "list", "section", "item"], {}, activityStylesheet));
					let label1 = filterEmptyProps(getStyleAttribute(_item, [hierarchicalActivityStyles, hierarchicalListStyles, hierarchicalSectionStyles], ["label", "label1"], item, activityStylesheet));
					let label2 = filterEmptyProps(getStyleAttribute(_item, [hierarchicalActivityStyles, hierarchicalListStyles, hierarchicalSectionStyles], ["label", "label2"], item, activityStylesheet));
					label1 = _.assign({}, _.pick(item, HIERARCHICAL_STYLE_PROPS), label1);
					label2 = _.assign({}, _.pick(item, HIERARCHICAL_STYLE_PROPS), label2);


					const additionalStyles = {};
					const additionalLabel1Styles = {};
					const additionalLabel2Styles = {};

					if (_item.labelOnly && _item.hasOwnProperty("labelOnlyBackgroundColor") && !_.isEmpty(_item.labelOnlyBackgroundColor)) {
						additionalStyles.backgroundColor = _item.labelOnlyBackgroundColor;
					} else if (_item.hasOwnProperty("backgroundColor") && !_.isEmpty(_item.backgroundColor)) {
						additionalStyles.backgroundColor = _item.backgroundColor;
					}

					if (_item.labelOnly && (!additionalStyles.backgroundColor || _.isEmpty(additionalStyles.backgroundColor))) {
						additionalStyles.backgroundColor = theme.item.labelOnly.backgroundColor;
					}

					if (_item.hasOwnProperty("label1Color") && !_.isEmpty(_item.label1Color)) {
						additionalLabel1Styles.color = _item.label1Color;
					} else if (_item.hasOwnProperty("color") && !_.isEmpty(_item.color)) {
						additionalLabel1Styles.color = _item.color;
					}

					if (_item.hasOwnProperty("label2Color") && !_.isEmpty(_item.label2Color)) {
						additionalLabel2Styles.color = _item.label2Color;
					}

					item = _.assign({}, theme.item.base, additionalStyles, item);

					label1 = _.assign({}, label1, additionalLabel1Styles);
					if (!label1.hasOwnProperty("color") || _.isEmpty(label1.color)) {
						label1.color = theme.item.color;
					}
					label2 = _.assign({}, label2, additionalLabel2Styles);
					if (!label2.hasOwnProperty("color") || _.isEmpty(label2.color)) {
						label2.color = theme.item.color;
					}

					const itemOkButton = _.assign({}, itemButtonOkStyles, getStyleAttribute({}, [hierarchicalActivityStyles, hierarchicalListStyles, hierarchicalSectionStyles, _.pick(item, HIERARCHICAL_STYLE_PROPS)], "itemButtonOk", {}, activityStylesheet));
					let _itemButtonOkVisibility = itemButtonOkVisibility;
					if (_item.itemButtonOkVisibility && !_.isEmpty(_item.itemButtonOkVisibility)) {
						_itemButtonOkVisibility = _item.itemButtonOkVisibility;
					}

					let _itemButtonOkLabel = itemButtonOkLabel;

					if (_item.itemButtonOkLabel && !_.isEmpty(_item.itemButtonOkLabel)) {
						_itemButtonOkLabel = _item.itemButtonOkLabel;
					}

					if (_itemButtonOkLabel) {
						_item.itemButtonOkLabel = _itemButtonOkLabel;
					}

					if (_itemButtonOkVisibility) {
						_item.itemButtonOkVisibility = _itemButtonOkVisibility;
					}

					_item.resolvedStyles = {
						item,
						label1,
						label2,
						itemOkButton
					};

				});
			});
		});
	} catch (e) {
		console.error(e);
	}


	// console.timeEnd("Calculate Styles");
}
*/


/**
 * The idea behind this is that all styles will be calculated prior to launching the activity in
 * order to avoid tons of styles being passed down the component tree and on the fly calculations.
 * @param {*} activity 
 */
export function resolveHierarchicalProperties(activity, theme) {
	try {
		//setDebugConsoleText("Starting resolveAllActivityStyles");
		//const timeStart = Date.now();

		const activitySuppressAudio = !!activity.suppressAudio;
		// console.log("Activity suppress audio", activity.suppressAudio);

		// console.time("Calculate Styles");
		const self = this;
		// To capture any hierarchical group dependencies
		//let groupHierarchies = {};
		const hierarchicalActivityStyles = _.pick(this.getStyleAttribute(activity, [], "activity", {}), HIERARCHICAL_STYLE_PROPS);
		// const activityStylesHash = hash(activityStyles);
		const activityStylesheet = activity.stylesheet;
		// const activityStylesheetHash = hash(activityStylesheet);
		//const activityClasses = activity.classes;
		// const activityClassesHash = hash(activityClasses);

		let procedureViewType = activity.hasOwnProperty("procedureViewType") ? activity.procedureViewType : "default";

		// const theme = activity.theme;
		const itemButtonOkStyles = _.get(theme, "item.buttonOk", {});
		// const themeHash = hash(theme);
		let itemButtonOkLabel = null;
		let itemButtonOkVisibility = null;

		if (activity.itemButtonOkVisibility && !_.isEmpty(activity.itemButtonOkVisibility)) {
			itemButtonOkVisibility = activity.itemButtonOkVisibility;
		}

		if (activity.itemButtonOkLabel && !_.isEmpty(activity.itemButtonOkLabel)) {
			itemButtonOkLabel = activity.itemButtonOkLabel;
		}

		activity.children.forEach(_list => {


			if (_list.itemButtonOkVisibility && !_.isEmpty(_list.itemButtonOkVisibility)) {
				itemButtonOkVisibility = _list.itemButtonOkVisibility;
			}

			if (_list.itemButtonOkLabel && !_.isEmpty(_list.itemButtonOkLabel)) {
				itemButtonOkLabel = _list.itemButtonOkLabel;
			}

			if (_list.hasOwnProperty("procedureViewType") && _list.procedureViewType !== "inherit") {
				procedureViewType = _list.procedureViewType;
			}

			const listSuppressAudio = activitySuppressAudio || !!_list.suppressAudio;
			// console.log("List suppress audio", _list.suppressAudio, listSuppressAudio);
			_list.suppressAudio = listSuppressAudio;
			const hierarchicalListStyles = _.pick(_list.styles, HIERARCHICAL_STYLE_PROPS);
			// const listStylesHash = hash(listStyles);
			let list = filterEmptyProps(self.getStyleAttribute(_list, [hierarchicalActivityStyles], ["activity", "list"], {}, activityStylesheet));
			const title = filterEmptyProps(_.pick(self.getStyleAttribute(_list, [hierarchicalActivityStyles], ["list", "title"]), HIERARCHICAL_STYLE_PROPS, {}, activityStylesheet));

			const additionalStyles = {};

			if (_list.hasOwnProperty("backgroundColor") && !_.isEmpty(_list.backgroundColor)) {
				additionalStyles.backgroundColor = _list.backgroundColor;
			}
			if (_list.hasOwnProperty("borderColor") && !_.isEmpty(_list.borderColor) && (!list.hasOwnProperty("borderColor") || _.isEmpty(list.borderColor))) {
				list.borderColor = _list.borderColor;
			}

			// TODO: Double check that later, hard coded for now
			list.borderRadius = 0;

			if (_list.hasOwnProperty("color") && !_.isEmpty(_list.color) && (!title.hasOwnProperty("color") || _.isEmpty(title.color))) {
				title.color = _list.color;
			}

			list = _.assign({}, theme.list, list, additionalStyles);

			_list.resolvedStyles = {
				list,
				title
			};
			// const listStylesHash = hash(listStyles);
			_list.children.forEach(_section => {
				const hierarchicalSectionStyles = _.pick(_section.styles, HIERARCHICAL_STYLE_PROPS);
				// const sectionStylesHash = hash(sectionStyles);
				const sectionSuppressAudio = listSuppressAudio || !!_section.suppressAudio;

				if (_section.hasOwnProperty("procedureViewType") && _section.procedureViewType !== "inherit") {
					procedureViewType = _section.procedureViewType;
				}
				// console.log("Section suppress audio", _section.suppressAudio, sectionSuppressAudio);
				_section.suppressAudio = sectionSuppressAudio;
				let section = filterEmptyProps(self.getStyleAttribute(_section, [hierarchicalActivityStyles, hierarchicalListStyles], ["activity", "list", "section"], {}, activityStylesheet));
				let title = filterEmptyProps(_.pick(self.getStyleAttribute(_section, [hierarchicalActivityStyles, hierarchicalListStyles], ["section", "title"], {}, activityStylesheet), HIERARCHICAL_STYLE_PROPS));

				const additionalStyles = {};

				if (_section.hasOwnProperty("backgroundColor") && !_.isEmpty(_section.backgroundColor)) {
					additionalStyles.backgroundColor = _section.backgroundColor;
				}

				section = _.assign({}, theme.section, section, additionalStyles);
				title = _.assign({}, _.pick(section, HIERARCHICAL_STYLE_PROPS), title);

				_section.resolvedStyles = {
					section,
					title
				};

				if (_section.itemButtonOkVisibility && !_.isEmpty(_section.itemButtonOkVisibility)) {
					itemButtonOkVisibility = _section.itemButtonOkVisibility;
				}

				if (_section.itemButtonOkLabel && !_.isEmpty(_section.itemButtonOkLabel)) {
					itemButtonOkLabel = _section.itemButtonOkLabel;
				}
				let conditionalVisibility = null;
				let groupItem = false;
				
				_section.children.forEach(_item => {
					let isLabelOnlyHeader = false;
					const itemSuppressAudio = sectionSuppressAudio || !!_item.suppressAudio;
					_item.suppressAudio = itemSuppressAudio;
					let targetStyleProperties = ["activity", "list", "section", "item"];
					
					if (_item.hasOwnProperty("groupNames") && !_.isEmpty(_item.groupNames)) {
						const startGroupRegex = RegExp("#+group-start", "g");
						const endGroupRegex = RegExp("#+group-end", "g");
						const joinedGroupNames = _item.groupNames.join("-");
						_item.isStartOfGroup = startGroupRegex.test(joinedGroupNames);
						if (_item.isStartOfGroup && _item.labelOnly) {
							// Ignore completion of label only AND header of a group
							_item.ignoreCompletion = true;
							_item.skipItem = true;
							targetStyleProperties = ["activity", "list", "section", "item", "containerHeader"];
							isLabelOnlyHeader = true;
						}

						if (_item.isStartOfGroup && _item.hasOwnProperty("conditionalVisible") && !_.isEmpty(_item.conditionalVisible)) {
							conditionalVisibility = _item.conditionalVisible;
						}

						if (_item.isStartOfGroup) {
							groupItem = true;
						}
						_item.isEndOfGroup = endGroupRegex.test(joinedGroupNames);
						if (_item.isEndOfGroup) {
							if (conditionalVisibility !== null) {
								console.log("Applying conditional visibility", _item.isEndOfGroup, conditionalVisibility);
								if (conditionalVisibility && conditionalVisibility.id && conditionalVisibility.ifThis && conditionalVisibility.ifThis.id && conditionalVisibility.thenThat && conditionalVisibility.thenThat.id) {

									const _conditionalVisibility = cloneDeep(conditionalVisibility);
									_conditionalVisibility.id = this.generateUUID();
									const ifThisId = this.generateUUID();
									const thenThatId = this.generateUUID();
									_conditionalVisibility.ifThis.id = ifThisId;
									_conditionalVisibility.thenThat.id = thenThatId;
									_conditionalVisibility.thenThat.sourceId = ifThisId;
									_item.conditionalVisible = _conditionalVisibility;
								}

							}
							conditionalVisibility = null;
						}
					}

					if (groupItem && !isLabelOnlyHeader) {
						targetStyleProperties = ["activity", "list", "section", "item", "containerItem"];
					}

					if (conditionalVisibility !== null && !_item.isStartOfGroup) {
						console.log("Applying conditional visibility", _item.isStartOfGroup, conditionalVisibility);
						if (conditionalVisibility && conditionalVisibility.id && conditionalVisibility.ifThis && conditionalVisibility.ifThis.id && conditionalVisibility.thenThat && conditionalVisibility.thenThat.id) {
							const _conditionalVisibility = cloneDeep(conditionalVisibility);
							_conditionalVisibility.id = this.generateUUID();
							const ifThisId = this.generateUUID();
							const thenThatId = this.generateUUID();
							_conditionalVisibility.ifThis.id = ifThisId;
							_conditionalVisibility.thenThat.id = thenThatId;
							_conditionalVisibility.thenThat.sourceId = ifThisId;
							_item.conditionalVisible = _conditionalVisibility;
						}
					}					

					let _procedureViewType = procedureViewType;

					if (_item.hasOwnProperty("procedureViewType") && _item.procedureViewType !== "inherit") {
						_procedureViewType = _item.procedureViewType;
					}
					_item.resolvedProcedureViewType = _procedureViewType;
					let item = filterEmptyProps(self.getStyleAttribute(_item, [hierarchicalActivityStyles, hierarchicalListStyles, hierarchicalSectionStyles], targetStyleProperties, {}, activityStylesheet));
					let label1 = filterEmptyProps(self.getStyleAttribute(_item, [hierarchicalActivityStyles, hierarchicalListStyles, hierarchicalSectionStyles], ["label", "label1"], item, activityStylesheet));
					let label2 = filterEmptyProps(self.getStyleAttribute(_item, [hierarchicalActivityStyles, hierarchicalListStyles, hierarchicalSectionStyles], ["label", "label2"], item, activityStylesheet));
					label1 = _.assign({}, _.pick(item, HIERARCHICAL_STYLE_PROPS), label1);
					label2 = _.assign({}, _.pick(item, HIERARCHICAL_STYLE_PROPS), label2);

					const additionalStyles = {};
					if (_item.labelOnly && _item.hasOwnProperty("labelOnlyBackgroundColor") && !_.isEmpty(_item.labelOnlyBackgroundColor)) {
						additionalStyles.backgroundColor = _item.labelOnlyBackgroundColor;
					} else if (_item.hasOwnProperty("backgroundColor") && !_.isEmpty(_item.backgroundColor)) {
						additionalStyles.backgroundColor = _item.backgroundColor;
					}

					if (_item.labelOnly && (!additionalStyles.backgroundColor || _.isEmpty(additionalStyles.backgroundColor))) {
						additionalStyles.backgroundColor = theme.item.labelOnly.backgroundColor;
					}
					if (groupItem && !isLabelOnlyHeader) {
						item = _.assign({}, theme.item.base, theme.itemGroup.item, additionalStyles, item);
					} else if (isLabelOnlyHeader) {
						item = _.assign({}, theme.item.base, theme.itemGroup.header, additionalStyles, item);
					} else {
						item = _.assign({}, theme.item.base, additionalStyles, item);
					}

					const msLabel1 = cloneDeep(markdownStyles);
					msLabel1.listItem.marginBottom = 5;
					if (_item.hasOwnProperty("label1Color") && !_.isEmpty(_item.label1Color)) {
						msLabel1.text.color = _item.label1Color;
					} else if (_item.hasOwnProperty("color") && !_.isEmpty(_item.color)) {
						msLabel1.text.color = _item.color;
					}

					const msLabel2 = cloneDeep(markdownStyles);
					msLabel2.listItem.marginBottom = 5;
					if (_item.hasOwnProperty("label2Color") && !_.isEmpty(_item.label2Color)) {
						msLabel2.text.color = _item.label2Color;
					}

					if (!_item.labelOnly) {
						msLabel1.image.width = 180;
						msLabel1.image.height = 180;
						msLabel1.image.maxWidth = 180;
						msLabel1.image.maxHeight = 180;
						// msLabel1.video.width = 180;
						// msLabel1.video.height = 180;
						// msLabel1.video.maxWidth = 180;
						// msLabel1.video.maxHeight = 180;
						msLabel2.image.width = 180;
						msLabel2.image.height = 180;
						msLabel2.image.maxWidth = 180;
						msLabel2.image.maxHeight = 180;
						// msLabel2.video.width = 180;
						// msLabel2.video.height = 180;
						// msLabel2.video.maxWidth = 180;
						// msLabel2.video.maxHeight = 180;
					}

					let _msLabel1 = getCustomizedMarkdownStyles(msLabel1, label1, {}, activity.startInShowMode);
					if (!_msLabel1.hasOwnProperty("color") || _.isEmpty(_msLabel1.text.color)) {
						_msLabel1.color = theme.item.color;
					}


					let _msLabel2 = getCustomizedMarkdownStyles(msLabel2, label2, {}, activity.startInShowMode);
					if (!_msLabel2.hasOwnProperty("color") || _.isEmpty(_msLabel2.color)) {
						_msLabel2.color = theme.item.color;
					}

					const itemOkButton = _.assign({}, itemButtonOkStyles, self.getStyleAttribute({}, [hierarchicalActivityStyles, hierarchicalListStyles, hierarchicalSectionStyles, _.pick(item, HIERARCHICAL_STYLE_PROPS)], "itemButtonOk", {}, activityStylesheet));

					let _itemButtonOkVisibility = itemButtonOkVisibility;

					if (_item.itemButtonOkVisibility && !_.isEmpty(_item.itemButtonOkVisibility)) {
						_itemButtonOkVisibility = _item.itemButtonOkVisibility;
					}

					// Prevent the global itemButtonOkLabel from be overwritten by previous sibling and then set for every other sibling.
					let _itemButtonOkLabel = itemButtonOkLabel;

					if (_item.itemButtonOkLabel && !_.isEmpty(_item.itemButtonOkLabel)) {
						_itemButtonOkLabel = _item.itemButtonOkLabel;
					}

					if (_itemButtonOkLabel) {
						_item.itemButtonOkLabel = _itemButtonOkLabel;
					}

					if (_itemButtonOkVisibility) {
						_item.itemButtonOkVisibility = _itemButtonOkVisibility;
					}
					if (_item.isEndOfGroup) {
						groupItem = false;
					}
					_item.resolvedStyles = {
						item,
						label1,
						label2,
						msLabel1: _msLabel1,
						msLabel2: _msLabel2,
						itemOkButton
					};
				});
			});
		});

		// console.timeEnd("Calculate Styles");
		//setDebugConsoleText(`Finished resolveAllActivityStyles [${(Date.now() - timeStart)} ms]`);
	} catch (e) {
		console.error(e);
	}

}


function filterEmptyProps(obj) {
	let result = {};
	_.keys(obj).forEach(key => {
		const value = obj[key];
		let add = !_.isNull(value) && !_.isUndefined(value);
		if (_.isString(value)) {
			add = add && !_.isEmpty(value);
		}
		if (add) {
			result[key] = obj[key];
		}
	});
	return result;
}

export function getSelectedStyles(styles, isSelected = true) {
	const result = {};
	const targetIdx = isSelected ? 0 : -1;
	_.keys(styles).forEach(key => {
		if (key.indexOf("selected") === targetIdx) {
			const ccKey = _.camelCase(key.replace("selected", ""));
			result[ccKey] = styles[key];
		}
	});

	return result;
}

export function getPrefixedStyles(styles, prefix = null) {
	const result = {};
	_.keys(styles).forEach(key => {
		if (key.indexOf(prefix) === 0) {
			const ccKey = _.camelCase(key.replace(prefix, ""));
			result[ccKey] = styles[key];
		}
	});

	return result;
}

export function deleteAllObjectKeys(object) {
	Object.keys(object).forEach(function (key) { delete object[key]; });
}

export function fixFileNameForS3(fileName) {
	// console.log("Fix fileName", fileName);
	if (fileName && _.isString(fileName)) {
		const parts = fileName.split(".");

		const newParts = [];
		_.each(parts, part => {
			newParts.push(part.replace(/\W+/g, "-"));
		});
		// console.log("Fixed", newParts);
		return newParts.join(".");
	} else {
		return fileName;
	}
}

export function getFontStyles(styles) {
	let result = {};

	if (styles) {
		result = _.pick(styles, ["fontSize", "color", "fontFamily", "fontWeight", "fontStyle"]);
	}

	return result;
}

export function getActivityMetaData(activityId) {

	let activities = state.get(PlayerPaths.ACTIVITIES);

	let activity = _.find(activities, { id: activityId });

	let metadata = {};
	if (!_.isUndefined(activity)) {
		metadata = activity;
	}
	return metadata;
}

export function getCompletionStateColor(completionState) {
	let completedColor = "#BA282A";
	if (completionState === "i") {
		completedColor = "#F9A200";
	} else if (completionState === "c") {
		completedColor = "#4f7017";
	}
	return completedColor;
}

export function getRealName(name) {
	let names = name.split("|");

	return names[0].trim();
}

export function getFileNameFromPath(path) {
	return path.substring(path.lastIndexOf("/"), path.length);
}

export function stripExtension(file) {
	if (file.indexOf(".") === -1) {
		return file;
	} else {
		return file.substring(0, file.lastIndexOf("."));
	}
}

export function hasList(tree, listName) {
	let activity = tree.get(["activity"]);

	if (activity.hasOwnProperty("children")) {
		for (let i = 0; i < activity.children.length; i++) {
			let list = activity.children[i];

			if (getRealName(list.name).toLowerCase() === listName.toLowerCase()) {
				return true;
			}
		}
	}

	return false;
}

export function setSessionName(tree, listIndex, sectionIndex, itemIndex, value) {
	const currentItem = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
	if (currentItem.useAsSessionName) {
		const currentChecklist = tree.get("activity");
		const sessionName = !currentChecklist.hasOwnProperty("sessionName") ? {} : currentChecklist.sessionName;
		const targetSortKey = "name-" + listIndex + "-" + sectionIndex + "-" + itemIndex;
		sessionName[targetSortKey] = value;
		tree.set(["activity", "sessionName"], sessionName);
		// // console.log("SESS_NAME: Yes!", sessionName);
	} else {
		// // console.log("SESS_NAME: No!", currentItem);
	}
}

export function getIconForGenre(genre, genres) {
	let icon = "question";
	for (let i = 0; i < genres.length; i++) {
		let objGenre = genres[i];
		if (genre === objGenre.value) {
			icon = objGenre.icon;
		}
	}

	return icon;
}

export function getCurrentList(tree) {
	let listIndex = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"));
	return tree.get(PlayerPaths.ACTIVITY_LIST(listIndex));
}

export function getCurrentSection(tree) {
	let listIndex = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"));
	let sectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	return tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, sectionIndex));
}

export function getCurrentItem(tree=state) {
	const loc = getCurrentItemLocation(tree);

	if (loc !== null) {
		return getItem(tree, loc.listIndex, loc.sectionIndex, loc.itemIndex);
	}

	return null;
}

export function getCurrentItemLocation(tree) {
	const selectedItem = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selected"));
	if (!selectedItem) {
		return null;
	}

	return selectedItem;
}

export function getMoveForward(tree) {
	let section = this.getCurrentSection(tree);
	let list = this.getCurrentList(tree);

	let moveForward = tree.get(["moveForward"]);

	if (section.moveForward === true || section.moveForward === false) {
		moveForward = section.moveForward;
	} else if (section.moveForward !== "userPreference") { //if not userPreference do default and inherit		
		if (list.moveForward === true || list.moveForward === false) {
			moveForward = list.moveForward;
		}
	}
	return moveForward;
}

export function getFocusedModeBranchPath(tree) {
	let section = this.getCurrentSection(tree);
	let list = this.getCurrentList(tree);

	let path = ["focusedMode"];

	let listIndex = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"));
	let sectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);


	if (section.focusedMode === true || section.focusedMode === false) {
		path = PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "focusedMode");
	} else if (section.focusedMode !== "userPreference") { //if not userPreference do default and inherit		
		if (list.focusedMode === true || list.focusedMode === false) {
			path = PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "focusedMode");
		}
	}

	return path;
}

export function getDefaultColumnWidthBranchPath(tree) {
	let path = ["appPreferences", "defaultColumnWidth"];
	let list = this.getCurrentList(tree);
	let activity = tree.get(["activity"]);

	let listIndex = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"));
	let sectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	let section = tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, sectionIndex));

	if (section && _.isNumber(section.defaultColumnWidth)) {
		path = PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "defaultColumnWidth");	
	} else if ((!section || section.defaultColumnWidth !== "userPreference") && _.isNumber(list.defaultColumnWidth)) { //if not userPreference do default and inherit					
		path = PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "defaultColumnWidth");
	} else if (list.defaultColumnWidth !== "userPreference" && _.isNumber(activity.defaultColumnWidth)) {
		path = PlayerPaths.ACTIVITY_PROPERTY("defaultColumnWidth");
	}

	let listLargestWidth = tree.get(["dimensions", "listLargestColumnWidth"]);

	if (tree.get(path) > listLargestWidth) {
		tree.set(["dimensions", "listLargestColumnWidth"], tree.get(path));
	}

	path = ["dimensions", "listLargestColumnWidth"];

	return path;
}

export function getCommentsVisibilityBranchPath(tree, listIndex, sectionIndex, itemIndex) {
	// debugger;
	let path = PlayerPaths.ACTIVITY_PROPERTY("commentsVisibility");

	let list = tree.get(PlayerPaths.ACTIVITY_LIST(listIndex));
	let section = tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, sectionIndex));
	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	if (item.commentsVisibility && item.commentsVisibility !== "inherit") {
		path = PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "commentsVisibility");
	} else if (section.commentsVisibility && section.commentsVisibility !== "inherit") {
		path = PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "commentsVisibility");
	} else if (list.commentsVisibility && list.commentsVisibility !== "inherit") {
		path = PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "commentsVisibility");
	}
	return path;
}

export function isPublished() {
	if (window.published) {
		return true;
	} else {
		return false;
	}
}

export function getPickerLabelforValue(pickerItems, values, pickerItemsDefinition = null) {
	let results = [];

	if (!_.isArray(values)) {
		values = [values];
	}

	let valueKey = "value";
	let labelKeys = ["label"];

	if (pickerItemsDefinition) {
		valueKey = _.first(pickerItemsDefinition.valueKeys);
		labelKeys = pickerItemsDefinition.labelKeys;
	}
	console.log("GET LABEL", valueKey, labelKeys, pickerItemsDefinition);
	for (let i = 0; i < pickerItems.length; i++) {
		values.forEach(value => {
			const pickerItem = pickerItems[i];
			const pickerItemValue = pickerItem[valueKey];
			if (pickerItemValue == value) { // eslint-disable-line
				let label = [];
				labelKeys.forEach(lk => {
					label.push(pickerItem[lk]);
				});
				results.push(label.join(" "));
			}
		});
	}
	console.log("GOT LABEL", results);
	return !_.isEmpty(results) ? results.join(" ") : "";
}

export function getCheckbarVisibility(tree) {
	let path = ["appPreferences", "checkbarLocation"];

	let activity = tree.get(PlayerPaths.ACTIVITY);
	if (activity && !_.isUndefined(activity.checkbarVisibility) && activity.checkbarVisibility !== "" && activity.checkbarVisibility !== "userPreference") {
		path = PlayerPaths.ACTIVITY_PROPERTY("checkbarVisibility");
	}
	return tree.get(path);
}

export function generateFluidFontSizeStyling(baseStyles, maxFontSizeFactor=.5, defaultValue) {
	let result = defaultValue;
	if (baseStyles && baseStyles.fontSize) {
		// Make responsive
		const currentFontSize = _.clone(baseStyles.fontSize);
		let fontSize = 20;
		let unit = "px";
		if (_.isString(currentFontSize) && (currentFontSize.indexOf("px") !== -1 || currentFontSize.indexOf("pt") !== -1 || currentFontSize.indexOf("em") !== -1)) {
			if (currentFontSize.indexOf("px") !== -1) {
				fontSize = _.toNumber(currentFontSize.trim().replace("px", ""));
			} else if (currentFontSize.indexOf("pt") !== -1) {
				fontSize = _.toNumber(currentFontSize.trim().replace("pt", ""));
				unit = "pt";
			} else {
				fontSize = _.toNumber(currentFontSize.trim().replace("em", ""));
				unit = "em";
			}
		} else if (_.isNumber(currentFontSize) || (_.isString(currentFontSize) && /^[0-9]+$/.test(currentFontSize))) {
			fontSize = _.isNumber(currentFontSize) ? currentFontSize : _.toNumber(currentFontSize);
		}

		if (_.isNumber(fontSize) && !_.isNaN(fontSize) && fontSize > -1) {
			// Assign calc
			// result = `${fontSize}${unit}`;
			let measurementBase = "100vw";
			if (window.innerHeight < window.innerWidth) {
				measurementBase = "100vh";
			}

			result = `calc(${fontSize}${unit} + ${(maxFontSizeFactor * fontSize)} * ((${measurementBase} - 320px) / 680))`;
		} else {
			console.warn("FONT SIZE INVALID FOR LABEL1", baseStyles.fontSize);
		}
	}

	return result;
}


export function getCustomizedMarkdownStyles(baseMarkdownStyles, styles, overrides = {}, showMode = false) {
	let result = {};

	// const hash1 = hash(baseMarkdownStyles);
	// const hash2 = hash(styles);
	// const hash3 = hash(overrides);
	// const cacheKey = `${hash1}-${hash2}-${hash3}`;
	// let result = baseMarkdownStyles;
	// if (stylingCache[cacheKey]) {
	// 	result = stylingCache[cacheKey];
	// } else if (styles && !_.isEmpty(styles)) {
	const textStyles = getFontStyles(styles);
	if (textStyles.hasOwnProperty("fontWeight") && !_.isString(textStyles.fontWeight)) {
		textStyles.fontWeight = "" + textStyles.fontWeight;
	}
	const markdownTextProps = _.pick(baseMarkdownStyles, ["codeBlock", "codeInline", "del", "em", "heading", "heading1", "heading2", "heading3", "heading4", "heading5", "heading6", "blockquote", "inlineCode", "paragraph", "listOrderedItemText", "listUnorderedItemText", "listUnorderedItemIcon", "listOrderedItemIcon", "strong", "tableHeaderCell", "text", "u"]);
	const overrideMarkdownStyles = {};

	_.keys(markdownTextProps).forEach(mdKey => {
		if (baseMarkdownStyles && baseMarkdownStyles.hasOwnProperty(mdKey)) {
			let _textStyles = cloneDeep(textStyles);
			if (_textStyles.hasOwnProperty("fontSize")) {
				if (mdKey.indexOf("heading") === 0) {
					let targetFontSize = _textStyles.fontSize;
					switch (mdKey) {
						case "heading1": {
							targetFontSize *= 2;
							break;
						}
						case "heading2": {
							targetFontSize *= 1.5;
							break;
						}
						case "heading3": {
							targetFontSize *= 1.12;
							break;
						}
						case "heading5": {
							targetFontSize *= 0.85;
							break;
						}
						case "heading6": {
							targetFontSize *= 0.7;
							break;
						}
						default: {
							targetFontSize = _textStyles.fontSize;
						}
					}
					if (showMode) {
						//_textStyles.fontSize = RFValue(Math.floor(targetFontSize));
						_textStyles.fontSize = Math.floor(targetFontSize);
					} else {
						_textStyles.fontSize = Math.ceil(targetFontSize);

					}

					// if (_textStyles.fontSize > 20) {
					_textStyles.lineHeight = _textStyles.fontSize + Math.ceil(_textStyles.fontSize / 10);
					_textStyles.paddingTop = Math.ceil(_textStyles.fontSize * .12);
					// }


				}
				if (mdKey === "listUnorderedItemIcon" || mdKey === "listOrderedItemIcon" || mdKey === "listUnorderedItemText" || mdKey === "listOrderedItemText" || mdKey === "text") {
					if (showMode) {
						//_textStyles.fontSize = RFValue(Math.floor(_textStyles.fontSize));
						_textStyles.fontSize = Math.floor(_textStyles.fontSize);
					}

					// if (_textStyles.fontSize > 20) {
					_textStyles.lineHeight = _textStyles.fontSize + Math.ceil(_textStyles.fontSize / 10);
					_textStyles.paddingTop = Math.ceil(_textStyles.fontSize * .12);
					// }
				}
			}

			overrideMarkdownStyles[mdKey] = _.assign({}, baseMarkdownStyles[mdKey], _textStyles);
		}
	});

	result = deepmerge.all([_.assign({}, baseMarkdownStyles, overrideMarkdownStyles), overrides]);
	// stylingCache[cacheKey] = result;
	// }





	return result;
}

export function getUtcTimestamp() {
	// ISO 8601
	return moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
}

export function isInChecklists(tree, id) {
	let checklists = tree.get(["activities"]);

	for (let i = 0; i < checklists.length; i++) {
		let checklist = checklists[i];

		if (checklist.id === id) {
			return true;
		}
	}

	return false;
}

export function isValidLinkAction(linkActionType, linkId) {
	let isValidLinkAction = false;

	linkActionType = linkActionType.toLowerCase();

	if (
		linkActionType.startsWith("resetcurrentchecklist") ||
		linkActionType.startsWith("resetcurrentactivity") ||
		linkActionType.startsWith("resetcurrentlist") ||
		linkActionType.startsWith("resetcurrentsection") ||
		linkActionType.startsWith("saveactivityandexit") ||
		linkActionType.startsWith("opencomments") ||
		linkActionType.startsWith("opennotes") ||
		linkActionType.startsWith("openmedia") ||
		linkActionType.startsWith("opensketchpad") ||
		linkActionType.startsWith("goback")
	) {
		isValidLinkAction = true;
	} else if (
		linkActionType.startsWith("external") ||
		linkActionType.startsWith("openitemmodal") ||
		linkActionType.startsWith("showmodalitem") ||
		linkActionType.startsWith("goto") ||
		linkActionType.startsWith("newsessionandgoto") ||
		linkActionType.startsWith("gotoandreturn") ||
		linkActionType.startsWith("newsessionandgotoandreturn") ||
		linkActionType.startsWith("resetrangeandgoto") || 
		linkActionType.startsWith("gotoandopenbirdseyeview:")
	) {
		if (linkId !== "") {
			isValidLinkAction = true;
		}
	}

	return isValidLinkAction;
}

export function linkActionNavigates(linkActionType) {
	let linkActionNavigates = false;

	if (
		linkActionType.startsWith("external") ||
		linkActionType.startsWith("goto") ||
		linkActionType.startsWith("newsessionandgoto") ||
		linkActionType.startsWith("gotoandreturn") ||
		linkActionType.startsWith("newsessionandgotoandreturn") ||
		linkActionType.startsWith("resetrangeandgoto") || 
		linkActionType.startsWith("gotoandopenbirdseyeview")
	) {
		linkActionNavigates = true;
	}

	return linkActionNavigates;
}


export function getLinkInfo(item, value) {
	if (item.type === "itemYesNo") {
		const linkOnSelect = (item.hasOwnProperty("yesNoLinkOnSelect") ? item.yesNoLinkOnSelect : false);
		const yesLinkId = (item.hasOwnProperty("yesNoYesLinkId") ? item.yesNoYesLinkId : "");
		const noLinkId = (item.hasOwnProperty("yesNoNoLinkId") ? item.yesNoNoLinkId : "");
		const naLinkId = (item.hasOwnProperty("yesNoNaLinkId") ? item.yesNoNaLinkId : "");
		const linkActionType = (item.hasOwnProperty("yesNoLinkActionType") ? item.yesNoLinkActionType : "goto");

		let linkId = "";
		let _linkActionType = item.yesNoLinkActionType;
		if (value === "yes") {
			let yesLinkActionType = (item.hasOwnProperty("yesLinkActionType") ? item.yesLinkActionType : linkActionType);
			if (yesLinkActionType === "inherit") {
				yesLinkActionType = _linkActionType;
			}
			_linkActionType = yesLinkActionType;
			linkId = yesLinkId;
		} else if (value === "no") {
			let noLinkActionType = (item.hasOwnProperty("noLinkActionType") ? item.noLinkActionType : linkActionType);
			if (noLinkActionType === "inherit") {
				noLinkActionType = _linkActionType;
			}
			_linkActionType = noLinkActionType;
			linkId = noLinkId;
		} else if (value === "n/a") {
			let naLinkActionType = (item.hasOwnProperty("naLinkActionType") ? item.naLinkActionType : linkActionType);
			if (naLinkActionType === "inherit") {
				naLinkActionType = _linkActionType;
			}
			_linkActionType = naLinkActionType;
			linkId = naLinkId;
		}

		return {
			linkOnSelect: linkOnSelect,
			linkActionType: _linkActionType,
			yesLinkId: yesLinkId,
			noLinkId: noLinkId,
			naLinkId: naLinkId,
			linkId: linkId,
			isValidLinkAction: isValidLinkAction(_linkActionType, linkId),
			linkActionNavigates: linkActionNavigates(_linkActionType)
		};
	} else if (item.type === "itemPicker") {
		let pickerLinkOnSelect = (item.hasOwnProperty("pickerLinkOnSelect") ? item.pickerLinkOnSelect : false);
		let pickerLinkId = "";
		let pickerLinkActionType = (item.hasOwnProperty("pickerLinkActionType") ? item.pickerLinkActionType : "goto");

		let pickerItem = _.find(item.pickerItems, function (o) { return o.value === value; });

		if (pickerItem && pickerItem.hasOwnProperty("properties") && pickerItem.properties !== "") {
			let properties = pickerItem.properties;

			let propertiesObject = JSON.parse(properties);
			Object.assign(pickerItem, propertiesObject);

			pickerLinkOnSelect = true;

			const pickerItemParts = pickerItem.linking.split(":");

			if (pickerItemParts.length > 1) {
				pickerLinkActionType = pickerItemParts[0];
				pickerLinkId = pickerItemParts[1];
			} else {
				pickerLinkActionType = pickerItemParts[0];
			}
		} else if (pickerItem && pickerItem.hasOwnProperty("value")) {
			pickerLinkId = "#" + pickerItem.value;
		}

		return {
			linkOnSelect: pickerLinkOnSelect,
			linkActionType: pickerLinkActionType,
			linkId: pickerLinkId,
			isValidLinkAction: isValidLinkAction(pickerLinkActionType, pickerLinkId),
			linkActionNavigates: linkActionNavigates(pickerLinkActionType)
		};
	} else {
		const itemLinkOnSelect = (item.hasOwnProperty("linkOnSelect") ? item.linkOnSelect : false);
		let itemLinkId = (item.hasOwnProperty("linkId") ? item.linkId : "");
		let itemLinkActionType = (item.hasOwnProperty("linkActionType") ? item.linkActionType : "goto");

		return {
			linkOnSelect: itemLinkOnSelect,
			linkActionType: itemLinkActionType,
			linkId: itemLinkId,
			isValidLinkAction: isValidLinkAction(itemLinkActionType, itemLinkId),
			linkActionNavigates: linkActionNavigates(itemLinkActionType)
		};
	}
}

export function getItem(tree = state, listIndex, sectionIndex, itemIndex) {
	let currentChecklist = tree.get(["activity"]);
	if (!currentChecklist || !currentChecklist.hasOwnProperty("selected")) {
		return null;
	}

	return tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
}

export function resolveVars(value) {
	if (value === "") {
		return "";
	}

	let _user = state.get(["user"]);

	let result = value; // eslint-disable-line

	try {
		// Make a monkey
		let displayName = "Unknown";
		let username = "Unknown";

		if (_user) {
			username = _user.username;
		}

		if (_user && _user.member) {
			displayName = _user.member.displayName;
		}

		let nameParts = displayName.split(" ");
		let initials = "";
		for (let i = 0; i < nameParts.length; i++) {
			let namePart = nameParts[i];
			initials = initials + namePart[0].toLowerCase();
		}

		const user = { // eslint-disable-line
			username: username,
			name: displayName,
			initials
		};

		// return eval(`\`${value}\``);
		return matchReplaceAll(STRING_TEMPLATE_VARIABLE, value, (match) => {
			// // console.log("IFTTT Replace/Match", match[1], eval(match[1]));
			return eval(match[1]); // eslint-disable-line no-eval
		});
	} catch (e) {
		console.error(e, _user);
		return value;
	}
}

export function getListDefaultView(tree, listIndex) {
	let defaultView = "checklistView";

	let currentChecklist = tree.get(["activity"]);
	let list = tree.get(["activity", "children", listIndex]);

	//if list is inherit, not set, or generated by normalization, use checklist defaultView value
	if (list.defaultView === "inherit" || list.defaultView === "" || _.isUndefined(list.defaultView) || list.insertedByNormalization) {
		//no default view set, use checklistView instead			
		if (currentChecklist.defaultView) {
			defaultView = currentChecklist.defaultView;
		}					
	} else {
		defaultView = list.defaultView;
	}

	return defaultView;
}